import { ApplicationRef, ComponentFactoryResolver, Injectable, Renderer2, RendererFactory2 } from "@angular/core";
import MapboxDraw from '@mapbox/mapbox-gl-draw';

import * as mapboxgl from "mapbox-gl";
import { TurfHelperService } from "./turf-helper.service";
import { HttpClient } from "@angular/common/http";
import { environment } from "../environments/environment";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import { BehaviorSubject, Observable, Subscription, catchError, filter, first, map, of } from "rxjs";
import { FeatureCollection, Point, Polygon } from "@turf/turf";
import { ViewContainerRef, Injector, ComponentRef  } from '@angular/core';
import { GeofencesService } from "src/app/features/geofences-map/services/Geofences.service";
import { LayerDTO } from "src/app/features/locations-map/models/LayerDTO";
import { LocationCategoryDTO } from "src/app/features/locations-map/models/LocationCategoryDTO";
import { GeoClustersFrecuencyPlacesService } from "src/app/features/locations-map/services/GeoClustersFrecuencyPlaces.service";
import { LocationRelatedService } from "src/app/features/locations-map/services/LocationRelated.service";
import { LocationsService } from "src/app/features/locations-map/services/Locations.service";
import { ToolCarsSelectorService } from "src/app/features/locations-map/services/Tool-Cars-Selector.service";
import { CarouselComponent } from "src/app/features/shared/features/carousel/components/carousel/carousel.component";
import { EnumBufferTypes } from "src/app/features/shared/helpers/enums/EnumBufferTypes";
import { EstatusJSON } from "src/app/features/shared/models/EstatusJSON";
import { CitronellaActionsService } from "src/app/features/shared/services/ServiceCatalogEncapsulators/CitronellaActions.service";
import { PanelDetailLocationsService } from "src/app/features/locations-map/services/Panel-Detail-Locations.service";
import { PanelLocationsService } from "src/app/features/locations-map/services/Panel-Locations.service";
import { PanelGeofencesService } from "src/app/features/geofences-map/services/Panel-Geofences.service";
import { PanelDetailGeofencesService } from "src/app/features/geofences-map/services/Panel-Detail-Geofences.service";
import { PanelAddGeofencesService } from "src/app/features/geofences-map/services/Panel-Add-Geofences.service";
import { PopupDetailGeoposService } from "src/app/features/routeMap/services/Popup-Detail-Geopos.service";
import { ValetParkingService } from "src/app/features/locations-map/services/ValetParking.service";
import { RouteSheetService } from "src/app/features/locations-map/services/RouteSheet.service";
import { ImageCacheService } from "src/app/features/shared/services/ImageCache.service";
import { SwalNotificationService } from "src/app/features/shared/services/SwalNotification.service";
import { RouteSheetLocationDTO } from "src/app/features/locations-map/models/RouteSheetLocationDTO";
import { MapUtilService } from "./MapUtil.service";
import { ToolInfoBoxService } from "src/app/features/locations-map/services/Tool-Info-Box.service";
import { EnumFeaturesActionsDestinations } from "src/app/features/shared/helpers/enums/EnumFeaturesActionsDestinations";
import { layouts } from "chart.js";
enum ROUTEMAP_LAYERS {
  Cars = "cars-layer",
  RealRoute = "realRoute-layer",
  Route = "route-layer",
  Geopos = "points-layer",
}

@Injectable({
  providedIn: "root",
})
export class MapHelperService {
  private viewContainerRef: ViewContainerRef;
  pitch: number = 0;

  PrintLayers() {
   console.log(this._map.getStyle().layers);
  }
  public Empty_GeoJson: any = {
    type: "FeatureCollection",
    features: [],
  };
  private configUrl = "";

  MapStyleName = Object.freeze({
    MapDaylight: "mapbox://mapbox.mapbox-streets-v6",
    MapNight: "mapbox://styles/danyelgtz/cl33z6spb001d16pjou3pqtf5",
    MapSatellite: "mapbox://mapbox.satellite",
  });
  PresentationMode: boolean;
  lat: number = 0;
  lng: number = 0;
  markers: mapboxgl.Marker[] = [];

  //intersección de capas
  polygonPoints: number[][] = []; // Almacena los puntos del polígono del add polygon
  activeLayers: LayerDTO[] = [];  //guarda las capas que están prendidas en los componentes de capas
  
  public featuresInsideArea = new BehaviorSubject< { featureCollection: FeatureCollection<Point>, destination: string } | null>(null);
  featuresInsideArea$ = this.featuresInsideArea.asObservable();

  //seleccion de zonas
  selectedFeatures: FeatureCollection<Polygon> = { type: "FeatureCollection", features: [] };
  public featuresSelected = new BehaviorSubject< { featureCollection: FeatureCollection<Polygon>, destination: string } | null>(null);
  featuresSelected$ = this.featuresSelected.asObservable();

  //para buffer
  bufferCenterLat: number = 0;
  bufferCenterLng: number = 0;
  bufferRadioKm: number = 0.5;


  mapMarkers = [];
  PinSelected: any;
  _containsControlFullScreen: boolean = false;
  _containsControlNavigation: boolean = false;
  _containsControlGeolocalization: boolean = false;
  style: string;
  container: string;
  zoom: number;
  dateMap: Date = new Date();
  geocoder: any;
  public _map: any;
  generalMapIconSize: number = 0.1011;

  private renderer: Renderer2;
  // variables para click en el mapa
  showStreetViewInfoBox = false;
  public infoBoxClick = new BehaviorSubject<{ lat: number, lng: number} | null>(null);
  infoBoxClick$ = this.infoBoxClick.asObservable();

  isMainSourceReady: boolean = false;
  isStyleReady: boolean = false;
  public mainSourceSubject = new BehaviorSubject<{ isMainSourceReady: boolean, isStyleReady: boolean } | null>(null);
  mainSource$ = this.mainSourceSubject.asObservable();
  public mapClickMarker!: mapboxgl.Marker;

  public locationsubscription: Subscription;
  public originalGeofencePolygonDrawData: any = null;
  isPolygonUpdateConfirmed: boolean = false;
  constructor(
    private http: HttpClient,
    private panelDetailLocationsService: PanelDetailLocationsService,
    private geofenceService: GeofencesService,
    private locationsService: LocationsService,
    private panelLocationsService: PanelLocationsService,
    private panelGeofencesService: PanelGeofencesService,
    private panelDetailGeofencesService: PanelDetailGeofencesService,
    private citronellaActionsService: CitronellaActionsService,
    private panelAddGeofencesService: PanelAddGeofencesService,
    private toolCarsSelectorservice: ToolCarsSelectorService,
    private popupDetailGeoposService: PopupDetailGeoposService,
    private turfHelperService: TurfHelperService,
    private valetParkingService: ValetParkingService,
    private rendererFactory: RendererFactory2,
    private geoClustersFrecuencyCatalogService: GeoClustersFrecuencyPlacesService,
    private locationRelatedCatalogService: LocationRelatedService,
    private routeSheetService: RouteSheetService,
    private imageCacheService : ImageCacheService,
    private notifyService: SwalNotificationService,
    private mapUtilService: MapUtilService,
    private toolInfoBox: ToolInfoBoxService,
    private swalNotificationService: SwalNotificationService
  ) {
    this.configUrl = environment.host;
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  public setViewContainerRef(vcr: ViewContainerRef) {
    this.viewContainerRef = vcr;
  }

  SetPresentationMode(op) {
    this.PresentationMode = op;
  }

  GetLayerByName(name: string): mapboxgl.Layer | undefined {
    return this._map.getLayer(name);
  }

  GetSourceByName(name: string): mapboxgl.GeoJSONSource | undefined {
    return this._map.getSource(name) as mapboxgl.GeoJSONSource;
  }

  ShowHideLayer(layerName: any) {
    const visibility = this._map.getLayoutProperty(layerName, "visibility");

    // Toggle layer visibility by changing the layout object's visibility property.
    if (visibility === "visible") {
      this._map.setLayoutProperty(layerName, "visibility", "none");
    } else {
      this._map.setLayoutProperty(layerName, "visibility", "visible");
    }
  }

  HideLayer(layerName: string) {
    var layer: mapboxgl.Layer = this._map.getLayer(layerName) as mapboxgl.Layer;
    if (layer !== undefined) {
      this._map.setLayoutProperty(layerName, "visibility", "none");
    }
  }

  HideLayersBySource(sourceName: string) {
    const layers = this._map.getStyle().layers.filter(l => l.source === sourceName);
    layers.forEach(layer => {
      this._map.setLayoutProperty(layer.id, "visibility", "none");
    });
  }

  ShowLayersBySource(sourceName: string) {
    const layers = this._map.getStyle().layers.filter(l => l.source === sourceName);
    layers.forEach(layer => {
      this._map.setLayoutProperty(layer.id, "visibility", "visible");
    });
  }

  ShowLayer(layerName: string) {
    var layer: mapboxgl.Layer = this._map.getLayer(layerName) as mapboxgl.Layer;
    if (layer !== undefined) {
      this._map.setLayoutProperty(layerName, "visibility", "visible");
    }
  }
  MoveLayer(layerToMove: string, destinationLayer: string) {
    var layer: mapboxgl.Layer = this._map.getLayer(layerToMove) as mapboxgl.Layer;
    if (layer !== undefined) {
      this._map.moveLayer(layerToMove, destinationLayer);
    }
  }
  MoveLayerToTop(layerName: string) {
    var layer: mapboxgl.Layer = this._map.getLayer(layerName) as mapboxgl.Layer;
    if (layer !== undefined) {
      this._map.moveLayer(layerName);
    }
  }

  SetBounds(sGeoJSONFeatures: any) {
    var b2 = this.turfHelperService.getBounds(sGeoJSONFeatures);
    this._map.fitBounds(b2, { padding: 250 });
  }

  UpdateLayerGeoJson(id: string, Data: any) {
    try {
      var SOURCE: mapboxgl.GeoJSONSource = this._map.getSource(
        id
      ) as mapboxgl.GeoJSONSource;
      console.log("Sustituyendo Geojson", id, SOURCE);
      if (SOURCE === undefined) {
        // this.initializeMapRoutes();
        // this.initializeMapGeofences();
        // this.initializeMapLocations();
      }
      if (SOURCE !== undefined) SOURCE.setData(Data);
    } catch (error) {
      console.log(error);
    }
  }

  UpdateLayerText(id: string, textoNuevo: string) {
    this._map.setLayoutProperty(id, "text-field", textoNuevo);
  }

  AddBaseMapSatellite() {
    var layer: mapboxgl.Layer = this._map.getLayer(
      "satellite-layer"
    ) as mapboxgl.Layer;
    if (layer === undefined) {
      this._map.addLayer({
        id: "satellite-layer",
        source: {
          type: "raster",
          url: this.MapStyleName.MapSatellite,
          tileSize: 256,
        },
        type: "raster",
      });
    }
  }

  AddSourceGeoJson(name: string, Data: any) {
    var obj = {
      id: name,
      type: "geojson",
      // Use a URL for the value for the `data` property.
      data: Data,
    };
    this._map.addSource(name, obj);
  }

  AddSourceClusteredEmptyGeoJson(name: string) {
    console.log("Adding source clustered empty geojson", name);
    
    var obj = {
      type: "geojson",
      // Use a URL for the value for the `data` property.
      data: this.Empty_GeoJson,
      cluster: true,
      clusterMaxZoom: 14, // Max zoom to cluster points on
      clusterRadius: 50, //
      generateId: true,
    };
    this._map.addSource(name, obj);
  }

  AddSourceEmptyGeoJson(name: string) {
    var layer = this._map.getLayer(name);
    try {
      if (layer === undefined) {
        var obj = {
          type: "geojson",
          // Use a URL for the value for the `data` property.
          data: this.Empty_GeoJson,
        };
        this._map.addSource(name, obj);
      }
    } catch (e) {}
  }

  AddSourceHighEmptyGeoJson(name: string) {
    var layer = this._map.getLayer(name);
    try {
      if (layer === undefined) {
        var obj = {
          type: "geojson",
          // Use a URL for the value for the `data` property.
          data: this.Empty_GeoJson,
        };
        this._map.addSource(name, obj);
      }
    } catch (e) {}
  }

  AddLayerCluster(id: string, source: string) {
    this._map.addLayer({
      id: id,
      type: "circle",
      source: source,
      filter: ["has", "point_count"],
      paint: {
        // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
        // with three steps to implement three types of circles:
        //   * Blue, 20px circles when point count is less than 100
        //   * Yellow, 30px circles when point count is between 100 and 750
        //   * Pink, 40px circles when point count is greater than or equal to 750
        "circle-color": [
          "step",
          ["get", "point_count"],
          "#51bbd6",
          100,
          "#f1f075",
          750,
          "#f28cb1",
        ],
        "circle-radius": ["step", ["get", "point_count"], 20, 100, 30, 750, 40],
      },
    });
  }

  AddLayerPolygons(id: string, source: string) {
    var layer = this._map.getLayer(id);
    try {
      if (layer === undefined) {
        this._map.addLayer({
          id: id,
          type: "fill",
          source: source,
          paint: {
            "fill-outline-color": "rgba(0,0,0,0.1)",
            "fill-color": "rgba(231,126,45,0.2)",
          },
        });
      }
    } catch (e) {}
  }

  AddLayerHeatmap(id: string, source: string) {
    this._map.addLayer({
      id: id,
      type: "fill",
      source: source,
      maxzoom: 9,
      paint: {
        // 'fill-color': [
        // 'interpolate',
        // ['linear'],
        // ['get', 'valor'],
        // 0,
        // '#c90076',
        // 50,
        // '#c90076',
        // 100,
        // '#c90076',
        // 150,
        // '#c90076',
        // 200,
        // '#c90076',
        // 250,
        // '#c90076',
        // 300,
        // '#c90076',
        // 500,
        // '#c90076',
        // 1000,
        // '#c90076'
        // ],
        "fill-color": "#0080ff",
        "fill-opacity": 0.75,
      },
    });
  }

  AddLayerGeofencesPolygons(id: string, source: string, color: string = "#808080") {
    var layer = this._map.getLayer(id);
    try {
      if (layer === undefined) {
        this._map.addLayer({
          id: id,
          type: "fill",
          source: source,
          paint: {
            "fill-color": [
              "match",
              ["get", "Status"],
                "1",
                "#9de02a", // Si Status es 1, usa este color
                "0",
                "#808080", // Si Status es 0, usa este color
                color, // Color predeterminado si no se cumple ninguna condición o viene de afuera
            ],
            "fill-opacity": [
              "match",
              ["get", "Status"],
                "1",
                0.4, // Si Status es 1 o 0, se ve
                "0",
                0.4,
                0,
            ],
          },
        });
      }
    } catch (e) {}
  }

  AddLayerCustomizablePolygons(id: string, source: string, opacity: number, color: string = "#6630fd", maxZoom: number = 22, minZoom: number = 0) {
    var layer = this._map.getLayer(id);
    try {
      if (layer === undefined) {
        this._map.addLayer({
          id: id,
          type: "fill",
          source: source,
          paint: {
            "fill-color": [
              "match",
              ["get", "Status"],
                "1",
                color,
                "0",
                "#808080", 
                color, 
            ],
            "fill-opacity": opacity,
          },
          maxzoom: maxZoom,
          minzoom: minZoom,
        });
      }
    } catch (e) {}
  }

  AddLayerGeofencesPolygonsWithFeatureStatus(id: string, source: string) {
    var layer = this._map.getLayer(id);
    try {
      if (layer === undefined) {
        this._map.addLayer({
          id: id,
          type: "fill",
          source: source,
          paint: {
            "fill-color": [
              "case",
              ['boolean', ['feature-state', 'selected'], false],
                "#f25d18", 
                "#808080",
            ],
            "fill-opacity": [
              "case",
              ['boolean', ['feature-state', 'hover'], false],
                0.6,
                0.4,
            ],
          },
        });
      }
    } catch (e) {}
  }

  AddLayerIconSmall(id: string, source: string, icon: string) {
    console.log("Loading layer icon");
    var layer = this._map.getLayer(id);
    try {
      if (layer === undefined) {
        this._map.addLayer({
          id: id,
          type: "symbol",
          source: source,
          layout: {
            "icon-allow-overlap": true,
            "icon-image": icon,
            "icon-size": 0.08,
          },
          paint: {
            "icon-color": "#e57620",
            "icon-halo-color": "#fff",
            "icon-halo-width": 2,
          },
        });
      }
    } catch (e) {
      console.log(e);
    }
  }
  AddLayerUnclusteredPoints(id: string, source: string) {
    this._map.addLayer({
      id: id,
      type: "symbol",
      source: source,
      filter: ["!", ["has", "point_count"]],
      layout: {
        "icon-allow-overlap": true,
        "icon-image": "car",
        "icon-size": 0.15,
      },
      paint: {
        "icon-color": "#22cbb6",
        "icon-halo-color": "#fff",
        "icon-halo-width": 2,
      },
    });
  }

  AddLayerUnclusteredPointsV2(id: string, source: string, icon: string, iconSize: number = 0.10) {
    // var iconImage = icon.replace(".png", "");
    this._map.addLayer({
      id: id,
      type: "symbol",
      source: source,
      filter: ["!", ["has", "point_count"]],
      layout: {
        "icon-allow-overlap": true,
        "icon-image": icon,
        "icon-size": iconSize,
        // 'icon-offset': [175, -175]
      },
      paint: {
        "icon-color": "#22cbb6",
        "icon-halo-color": "#fff",
        "icon-halo-width": 2,
      },
    });
  }

  AddLayerGeofencesPinRadar(id: string, source: string) {
    var layer = this._map.getLayer(id);
    try {
      if (layer === undefined) {
        this._map.addLayer({
          id: id,
          type: "symbol",
          source: source,
          maxzoom: 10,
          layout: {
            "icon-allow-overlap": true,
            "icon-image": [
              "case",
              ["==", ["get", "Status"], "1"], // Si Status es igual a 1
              "pulsingDot", // Usar el icono "fence"
              ["==", ["get", "Status"], "0"], // Si Status es igual a 0
              "pulsingDot",
              "", // Si no coincide con 1 ni con 0, no se muestra ningún icono
            ],
            "icon-size": 0.15,
          },
        });
      }
    } catch (e) {}
  }

  AddLayerGeofencesByStatus(id: string, source: string) {
    var layer = this._map.getLayer(id);
    try {
      if (layer === undefined) {
        this._map.addLayer({
          id: id,
          type: "symbol",
          source: source,
          maxzoom: 13,
          layout: {
            "icon-allow-overlap": true,
            "icon-image": [
              "case",
              ["==", ["get", "Status"], "1"], // Si Status es igual a 1
              "geofence.png", // Usar el icono "fence"
              ["==", ["get", "Status"], "0"], // Si Status es igual a 0
              "geofenceInactive.png",
              "geofenceInactive.png", // Si no coincide con 1 ni con 0, no se muestra ningún icono
            ],
            "icon-size": 0.15,
          },
        });
      }
    } catch (e) {}
  }
  AddCirclesLayerWithHex(id: string, source: string) {
    this._map.addLayer({
      id: id,
      type: "circle",
      source: source,
      paint: {
        "circle-radius": 10,
        "circle-color": ["get", "PinColorHex"],
        "circle-stroke-width": 1,
        "circle-stroke-color": "#fff",
        "circle-stroke-opacity": 1,
      },
    });
  }

  AddLayerLocationActive(id: string, source: string, categoryActiveIcon: string, iconSize: number = 0.25) {
    var image = categoryActiveIcon;
    this._map.addLayer({
      id: id,
      type: "symbol",
      source: source,
      filter: ["!", ["has", "point_count"]],
      layout: {
        // This icon is a part of the Mapbox Streets style.
        // To view all images available in a Mapbox style, open
        // the style in Mapbox Studio and click the "Images" tab.
        // To add a new image to the style at runtime see
        // https://docs.mapbox.com/mapbox-gl-js/example/add-image/
        'icon-image': image,
        "icon-size": iconSize,
        // 'icon-offset': [175, -175]
      },
      paint: {
        "icon-color": "#7DFF45",
        "icon-halo-color": "#fff",
        "icon-halo-width": 2,
      },
    });
  }

  AddLayerLocationsGeneral(id: string, source: string, iconProperty: string, iconSize: number = 0.15, allowOverlap: boolean = false) {
    this._map.addLayer({
      id: id,
      type: "symbol",
      source: source,
      filter: ["!", ["has", "point_count"]],
      layout: {
        'icon-image': ['get', iconProperty],
        "icon-size": iconSize,
        "icon-allow-overlap": allowOverlap,
        // 'icon-offset': [175, -175]
      },
      paint: {
        "icon-color": "#7DFF45",
        "icon-halo-color": "#fff",
        "icon-halo-width": 2,
      },
    });
  }

  AddLayerIcon(id: string, source: string, icon: string, iconSize: number = 0.15) {
    this._map.addLayer({
      id: id,
      type: "symbol",
      source: source,
      filter: ["!", ["has", "point_count"]],
      layout: {
        // This icon is a part of the Mapbox Streets style.
        // To view all images available in a Mapbox style, open
        // the style in Mapbox Studio and click the "Images" tab.
        // To add a new image to the style at runtime see
        // https://docs.mapbox.com/mapbox-gl-js/example/add-image/
        'icon-image': icon,
        "icon-size": iconSize,
        // 'icon-offset': [175, -175]
      },
      paint: {
        "icon-color": "#7DFF45",
        "icon-halo-color": "#fff",
        "icon-halo-width": 2,
      },
    });
  }


  AddLayerText(id: string, source: string, propiedadDisplay: string, offsetY: number, offsetX: number = 0) {
    console.log("ADDING ", id, source, propiedadDisplay);
    var layer = this._map.getLayer(id);
    try {
      if (layer == undefined) {
        this._map.addLayer({
          id: id,
          type: "symbol",
          source: source,
          layout: {
            "text-field": ["get", propiedadDisplay],
            "text-font": ["Open Sans Regular"],
            "text-size": 12,
            "text-offset": [offsetX, offsetY],
            "text-anchor": "bottom",
            "text-justify": "center",
            "text-max-width": 10,
            "text-line-height": 1.2,
            "text-allow-overlap": false,
            "text-ignore-placement": false,
            "symbol-placement": "point",
          },
          paint: {
            "text-color": "#530aa8",
            "text-halo-color": "#fff", // Contorno blanco
            "text-halo-width": 2,
          },
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  AddLayerTextH3(id: string, source: string, propiedadDisplay: string) {
    var layer = this._map.getLayer(id);
    try {
      if (layer === undefined) {
        this._map.addLayer({
          id: id,
          type: "symbol",
          source: source,
          filter: ["!", ["has", "point_count"]],
          layout: {
            "text-field": ["get", propiedadDisplay],
            "text-font": ["Open Sans Bold"],
            "text-size": 20,
            "text-offset": [0, -2],
            "text-anchor": "bottom",
          },
          paint: {
            "text-color": "#537aa8",
          },
        });
      }
    } catch (e) {}
  }

  AddLayerTextH3WithStatus(
    id: string,
    source: string,
    propiedadDisplay: string
  ) {
    var layer = this._map.getLayer(id);
    try {
      if (layer === undefined) {
        this._map.addLayer({
          id: id,
          type: "symbol",
          source: source,
          filter: ["!", ["has", "point_count"]],
          layout: {
            "text-field": [
              "case",
              ["==", ["get", "Status"], "-1"],
              "", // Si status es igual a -1 de la geocerca, establece el campo de texto como una cadena vacía
              ["get", propiedadDisplay],
            ],
            "text-font": ["Open Sans Bold"],
            "text-size": 15,
            "text-offset": [0, -2],
            "text-anchor": "bottom",
          },
          paint: {
            "text-color": "#530aa8",
          },
        });
      }
    } catch (e) {}
  }

  AddLayerPointActive(id: string, source: string) {
    this._map.addLayer({
      id: id,
      type: "symbol",
      source: source,
      filter: ["!", ["has", "point_count"]],
      layout: {
        // This icon is a part of the Mapbox Streets style.
        // To view all images available in a Mapbox style, open
        // the style in Mapbox Studio and click the "Images" tab.
        // To add a new image to the style at runtime see
        // https://docs.mapbox.com/mapbox-gl-js/example/add-image/
        "icon-image": "buffer-active",
        "icon-size": 0.1,
      },
      paint: {
        "icon-color": "#7DFF45",
        "icon-halo-color": "#fff",
        "icon-halo-width": 2,
      },
    });
  }

  AddLayerBufferActive(id: string, source: string, type: number) {
    this._map.addLayer({
      id: id,
      source: source,
      type: "fill",
      paint: {
        "fill-color": ["case",
          ["==", type, 1], // Si el tipo es igual a 1 es un buffer de geofence
          "#f25d18",
          ["==", type, 2], // Si el tipo es igual a 2 es un buffer de valet parking
          "#f2f218",
          "#f25d18"
        ],
        "fill-opacity": 0.4,
      },
    });
  }

  AddLayerBufferRecurrent(id: string, source: string, type: number) {
    this._map.addLayer({
      id: id,
      source: source,
      type: "fill",
      paint: {
        "fill-color": [
          "case",
          ["has", "color"],  // Si la propiedad 'color' existe
          ["get", "color"],
          "#f25d18"           // default
        ],
        "fill-opacity": 0.4,
      },
    });
  }

  AddLayerClusterCount(name: string, source: string) {
    this._map.addLayer({
      id: name,
      type: "symbol",
      source: source,
      filter: ["has", "point_count"],
      layout: {
        "text-field": "{point_count_abbreviated}",
        "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
        "text-size": 12,
      },
    });
  }

  addLayerCenterPoint(id: string, source: string) {
    this._map.addLayer({
      id: id,
      type: 'symbol',
      source: source,
      layout: {
        'icon-image': 'centerPin.png',
        'icon-size': 0.1,
        'icon-anchor': 'center',
        'icon-offset': [0, -200]
      }
    });
  }

  CreateMapUnique(
    Container: string,
    Style: string,
    Zoom: number,
    Lng: number,
    Lat: number,
    EnableFullScreen: boolean,
    EnableGeolocalization: boolean,
    EnableNavigation: boolean
  ) {
    this.CreateMap(Container, Style, Zoom, Lng, Lat);

    if (EnableFullScreen) {
      this.AddControlFullScreen();
    }
    if (EnableGeolocalization) {
      this.AddControlGeolocalization();
    }
    if (EnableNavigation) {
      this.AddControlNavigation();
    }
    
  }

  startTour() {
    this.InitialFly( "19.38463", "-99.09985", "10", 30 );

      setTimeout(() => {
        this.InitialFly( "19.38463", "-99.09589", "11", 75 );
    
        setTimeout(() => {
          this.TourCamera(7000);
        }, 1050);
    
      }, 2000);
  }

  onLoadMapLocations() {
    this._map.on("load", () => {
      try {
        var categoryIcons = JSON.parse(localStorage.getItem("UrlList"));
        categoryIcons.forEach(UrlSas => {
          if (UrlSas.url.includes(".png") || UrlSas.url.includes(".jpg") || UrlSas.url.includes(".jpeg") ) {
            const cachedDataUrl = this.imageCacheService.getMapixImage(UrlSas.name);
            if (cachedDataUrl) {
              // si está en cache, lo carga directo
              this._map.loadImage(cachedDataUrl, (error, image) => {
                if (error) throw error;
                if (!this._map.hasImage(UrlSas.name)) {
                  this._map.addImage(UrlSas.name, image, { sdf: false });
                }
              });
            }else{
              // var imageName = UrlSas.name.replace(".png", "");
              this._map.loadImage(UrlSas.url, (error, image) => {
                if (error) throw error;
                if (!this._map.hasImage(UrlSas.name))
                  this._map.addImage(UrlSas.name, image, { sdf: false });
              });
            }
          }
          // this._map.addImage('marker', 'animated');
        });
  
        if (!this._map.hasImage('startPoint-pulse')) {
          this._map.addImage('startPoint-pulse', pulsingDot, { pixelRatio: 2 });
        }
      } catch (error) {
        console.log(error);
      }

      this.initializeMapLocations();
      //this.UpdateLayerText("layer-locationActive-text", );

      var hoveredMarker = null;
      var hoveredMarkerFeature = null;
      var popup = new mapboxgl.Popup({});

      const layerMouseOver = (e) => {
        // Obtener ID del marcador
        const marker= e.features[0].properties;

        // Almacenar referencia al marcador
        hoveredMarker = marker;
        hoveredMarkerFeature = e.features[0];

        var categoryIcon = (hoveredMarker.LocationCategoryActiveIcon as string);
        
        // categoryIcon = categoryIcon.replace(".png", "A.png");

        // Cambiar icono del marcador (el primer case es para encontrar el feature y el segundo para cambiar el icono), el segundo es del filtro
        this._map.setLayoutProperty("layer-locationsGeneral", "icon-image", [
          "case",
          ["==", ["get", "_Id"], marker._Id],
          categoryIcon,
          ["get", "LocationCategoryIcon"]
        ]);
        this._map.setLayoutProperty("filter-layer-locationsGeneral", "icon-image", [
          "case",
          ["==", ["get", "_Id"], marker._Id],
          categoryIcon,
          ["get", "LocationCategoryIcon"]
        ]);

        // cambia el color del nombre
        this._map.setPaintProperty("layer-pinText", "text-color", [
          "case",
          ["==", ["get", "_Id"], marker._Id],
          "#0F010F",
          "#530aa8",
        ]);
        this._map.setPaintProperty("filter-layer-pinText", "text-color", [
          "case",
          ["==", ["get", "_Id"], marker._Id],
          "#0F010F",
          "#530aa8",
        ]);

        // Mostrar popup y lo guarda en la cariable para despues cerrarlo
        // popup = new mapboxgl.Popup({ offset: [0, -15] })
        //     .setLngLat(coordinates)
        //     .setHTML(`<h3>${nombre}</h3>`)
        //     .addTo(this._map);

      };

      const layerMouseLeave = () => {
        // Restaurar icono y texto del punto solo si hay un punto bajo el mouse
        if (hoveredMarker) {
          console.log("hoveredMarkerId", hoveredMarker);
          
           // Cambiar icono del marcador
          this._map.setLayoutProperty("layer-locationsGeneral", "icon-image", ["get", "LocationCategoryIcon"]);
          this._map.setPaintProperty("layer-pinText", "text-color", "#530aa8");

          this._map.setLayoutProperty("filter-layer-locationsGeneral", "icon-image", ["get", "LocationCategoryIcon"]);
          this._map.setPaintProperty("filter-layer-pinText", "text-color", "#530aa8");
          hoveredMarker = null;
        }

        // Cerrar popup si está abierto
        if (popup) {
          popup.remove();
          popup = null;
        }
      };

      let currentPopup: mapboxgl.Popup = null;
      let popupTimeoutId: any = null;
      let isMouseNearPopup = false;

      const categoryPopUpMouseOver = (e) => {
        // por si hay un popup anterior a medio cerrar
        if (popupTimeoutId) {
          clearTimeout(popupTimeoutId);
          popupTimeoutId = null;
        }
        if (currentPopup) {
          currentPopup.remove();
          currentPopup = null;
        }

        // Obtener ID del marcador
        const marker= e.features[0];
        var layerName = "";
        if(e.features && e.features[0] && e.features[0].layer && e.features[0].layer.id)
          layerName = e.features[0].layer.id;

        // Almacenar referencia al marcador
        hoveredMarker = marker;
        hoveredMarkerFeature = e.features[0];
        

        var categoryIcon = (hoveredMarker.properties.Icon as string);
        var categoryActiveIcon = categoryIcon.replace(".png", "A.png");
        

        // Cambiar icono del marcador (el primer case es para encontrar el feature y el segundo para cambiar el icono), el segundo es del filtro
        this._map.setLayoutProperty(layerName, "icon-image", [
          "case",
          ["==", ["get", "IdentifierChild"], marker.properties.IdentifierChild],
          categoryActiveIcon || categoryIcon,
          ["get", "Icon"]
        ]);

        const obj: any = e.features[0].properties;
        console.log("Objeto over", obj);
        
        const identifier: string = e.features[0].properties.IdentifierChild;
        const idLocationCategory: number = e.features[0].properties.IdLocationCategory;
        const description: string = e.features[0].properties.Description;
        const date: string = e.features[0].properties.CreatedIn;
        const name: string = e.features[0].properties.Title;
        const img: string = e.features[0].properties.Icon;
        const images = JSON.parse(localStorage.getItem("UrlList"));
        const imgUrl = images.find((x) => x.name === img);

        // Crea el componente dinámicamente y pone estilo
        const componentRef: ComponentRef<CarouselComponent> = this.viewContainerRef.createComponent(CarouselComponent);
        componentRef.instance.identifier = identifier;
        componentRef.instance.idLocationCategory = idLocationCategory;
        const carouselElement = componentRef.location.nativeElement;
        this.renderer.setStyle(carouselElement, 'display', 'flex');
        this.renderer.setStyle(carouselElement, 'height', '100%');
        this.renderer.setStyle(carouselElement, 'max-height', '120px');
  
        // Contenedor del popup
        const popupContainer = document.createElement('div');
        popupContainer.className = 'popup-container';
        popupContainer.style.position = 'relative';
        popupContainer.style.height = 'auto';
        popupContainer.style.display = 'flex';
        popupContainer.style.flexDirection = 'column';
        popupContainer.style.justifyContent = 'center';
      
        // para crear el carousel
        const carouselContainer = document.createElement('div');
        carouselContainer.style.width = "100%";
        // carouselContainer.style.minHeight = "15px";
        carouselContainer.style.maxHeight = "115px";
        carouselContainer.style.height = "auto";
        carouselContainer.style.overflow = 'hidden'; 
        carouselContainer.style.position = 'relative'; 
        // carouselContainer.style.marginTop = '8px'; 

        carouselContainer.appendChild(carouselElement);
        popupContainer.appendChild(carouselContainer);
      
        // Ttítulo con descripcion y clic
        const titleElement = document.createElement('h3');
        titleElement.innerText = description;
        titleElement.style.margin = '0 0 3px 10px';
        titleElement.style.color = '#3f51b5';
        titleElement.style.overflowX = 'auto';
        titleElement.style.overflowY = 'hidden';
        titleElement.style.maxHeight = '40px';
        titleElement.style.width = '90%';
        titleElement.style.whiteSpace = 'nowrap';
        titleElement.addEventListener('mouseover', () => {
          titleElement.style.color = '#31ab45';
          titleElement.style.textDecoration = 'underline';
          titleElement.style.cursor = 'pointer';
        });
        titleElement.addEventListener('mouseleave', () => {
          titleElement.style.color = '#3f51b5';
          titleElement.style.textDecoration = 'none';
        });
        var routeSheetLocationDTO = {
          identifierChild: identifier
        } as RouteSheetLocationDTO
        titleElement.addEventListener('click', () => {
          this.locationRelatedCatalogService.openRelatedDetailsPopup(identifier);
          this.routeSheetService.openRouteSheetDetailsPopup(routeSheetLocationDTO, "", "");
          this.clearPopupEvents("images-popup-routeSheet");
        });
        popupContainer.appendChild(titleElement);
      
        // descripción flex padre
        const descriptionElement = document.createElement('div');
        descriptionElement.style.height = '50px';
        descriptionElement.style.margin = '0';
        descriptionElement.style.display = 'flex';
        descriptionElement.style.flexDirection = 'row';
  
        //imagen a la izquierda
        const descriptionImageElement = document.createElement('img');
        descriptionImageElement.style.width = '25%';
        descriptionImageElement.style.objectFit = 'contain'; 
        descriptionImageElement.style.marginRight = '8px'; 
        // descriptionImageElement.style.borderRadius = '4px'; 
        descriptionImageElement.src = imgUrl?.url || ''; 
        descriptionElement.appendChild(descriptionImageElement);
  
        //flex con datos a la derecha
        const descriptionDataElement = document.createElement('div');
        descriptionDataElement.style.margin = '0';
        descriptionDataElement.style.display = 'flex';
        descriptionDataElement.style.flexDirection = 'column';
        descriptionElement.appendChild(descriptionDataElement);
  
        //titulo en los datos de la derecha
        const descriptionDataTitleElement = document.createElement('p');
        descriptionDataTitleElement.style.maxHeight = '25px';
        descriptionDataTitleElement.style.overflowX = 'auto';
        descriptionDataTitleElement.style.overflowY = 'hidden';
        descriptionDataTitleElement.style.margin = '0';
        descriptionDataTitleElement.style.whiteSpace = 'nowrap';
        descriptionDataTitleElement.style.fontWeight = 'bold';
        descriptionDataTitleElement.innerText = identifier;
        descriptionDataElement.appendChild(descriptionDataTitleElement);
  
        //fecha en los datos de la derecha
        const descriptionDataDateElement = document.createElement('p');
        descriptionDataDateElement.style.maxHeight = '25px';
        descriptionDataDateElement.style.overflowX = 'hidden';
        descriptionDataDateElement.style.overflowY = 'hidden';
        descriptionDataDateElement.style.margin = '0';
        descriptionDataDateElement.style.whiteSpace = 'nowrap';
        descriptionDataDateElement.innerText = date;
        descriptionDataElement.appendChild(descriptionDataDateElement);
  
        //nombre en los datos de la derecha
        const descriptionDataNameElement = document.createElement('p');
        descriptionDataNameElement.style.maxHeight = '25px';
        descriptionDataNameElement.style.overflowX = 'hidden';
        descriptionDataNameElement.style.overflowY = 'hidden';
        descriptionDataNameElement.style.margin = '0';
        descriptionDataNameElement.style.whiteSpace = 'nowrap';
        descriptionDataNameElement.style.fontWeight = 'bold';
        descriptionDataNameElement.innerText = name;
        descriptionDataElement.appendChild(descriptionDataNameElement);
  
        popupContainer.appendChild(descriptionElement);
      
        // Crear y mostrar el popup
        currentPopup = new mapboxgl.Popup(
          {
            closeButton: false,
            className: 'images-popup-routeSheet',
            offset: [0, -25],
          }
        ).setLngLat(e.lngLat).setDOMContent(popupContainer).addTo(this._map);

        // agrego que acepte el mouse sobre el popup para que no se cierre al estar encima y un tieout para que no se cierre sin querer
        const popupElement = currentPopup.getElement();
        if (popupElement) {
          popupElement.addEventListener('mouseenter', () => {
            isMouseNearPopup = true;
            if (popupTimeoutId) {
              clearTimeout(popupTimeoutId);
              popupTimeoutId = null;
            }
          });
  
          popupElement.addEventListener('mouseleave', () => {
            isMouseNearPopup = false;
            popupTimeoutId = setTimeout(() => {
              categoryPopUpMouseLeave();
            }, 100);
          });
        }
      };

      const categoryPopUpMouseLeave = () => {
        if (isMouseNearPopup) {
          return;
        }

        popupTimeoutId = setTimeout(() => {
          if (hoveredMarker && !isMouseNearPopup) {
            console.log("hoveredMarkerId", hoveredMarker);
            var layerName = hoveredMarker.layer.id;
            // Cambiar icono del marcador
            this._map.setLayoutProperty(layerName, "icon-image", ["get", "Icon"]);
            this._map.setPaintProperty(layerName + "-PinText", "text-color", "#530aa8");
  
            hoveredMarker = null;
          }
          if (currentPopup) {
            currentPopup.remove();
            currentPopup = null;
          }
        }, 100);
      };

      const layerMouseClick = (e) => {
        var obj: any = e.features[0].properties;
        console.log("Objeto Clicked", obj);
        var $identifier: string = obj._Id;
        var $locationCategory: string = obj.LocationCategory;
        
        // abre el detalle de carros desde el clic y comienza a cargar
        this.panelDetailLocationsService.setCategorySelected($locationCategory);
        setTimeout(() => {
          // this.panelDetailLocationsService.setVisibilityPopup(true);
          this.panelDetailLocationsService.setLoading(true);
        }, 500);
        this.onFocusPin($identifier);
      };

      const relatedCategoryMouseClick = (e) => {
        this.locationRelatedCatalogService.openRelatedDetailsPopup(e.features[0].properties.IdentifierChild);
      };
      const routeSheetMouseClick = (e) => {
        var routeSheetLocationDTO = {
          identifierChild: e.features[0].properties.IdentifierChild
        } as RouteSheetLocationDTO

        this.routeSheetService.openRouteSheetDetailsPopup(routeSheetLocationDTO, "", "");
      };

      // Evento mouseenter
      this._map.on("mouseenter", "layer-locationsGeneral", layerMouseOver);
      this._map.on("mouseenter", "filter-layer-locationsGeneral", layerMouseOver);

      this._map.on("mouseenter", "layer-pinText", layerMouseOver);
      this._map.on("mouseenter", "filter-layer-pinText", layerMouseOver);
      
      this._map.on("mouseenter", "layer-LocationRelated", categoryPopUpMouseOver);
      this._map.on("mouseenter", "layer-RouteSheetLocations-Services", categoryPopUpMouseOver);
      this._map.on("mouseenter", "layer-RouteSheetLocations-Unit", categoryPopUpMouseOver);

      // Evento mouseleave
      this._map.on("mouseleave", "layer-locationsGeneral", layerMouseLeave);
      this._map.on("mouseleave", "filter-layer-locationsGeneral", layerMouseLeave);

      this._map.on("mouseleave", "layer-pinText", layerMouseLeave);
      this._map.on("mouseleave", "filterlayer-pinText", layerMouseLeave);

      this._map.on("mouseleave", "layer-LocationRelated", categoryPopUpMouseLeave);
      this._map.on("mouseleave", "layer-RouteSheetLocations-Services", categoryPopUpMouseLeave);
      this._map.on("mouseleave", "layer-RouteSheetLocations-Unit", categoryPopUpMouseLeave);

      // Evento click
      this._map.on("click", "layer-locationsGeneral", layerMouseClick);

      this._map.on("click", "filter-layer-locationsGeneral", layerMouseClick);

      this._map.on("click", "layer-LocationRelated", relatedCategoryMouseClick);
      this._map.on("click", "layer-RouteSheetLocations-Services", routeSheetMouseClick);
      this._map.on("click", "layer-RouteSheetLocations-Unit", routeSheetMouseClick);

      this.toggleTraficLayer("none");

      this.isMainSourceReady = true;
      this.mainSourceSubject.next({ isMainSourceReady: this.isMainSourceReady, isStyleReady: this.isStyleReady });
    });

    //debe de mandar que los estilos estan listos UNA vez, pero por si a caso, se agregaron pipes con filtros y take en donde se usa la subscripción
    this._map.on('styledata', () => {
      var isStyleFullyLoaded = false;
      // console.log("----------------------estilo 1---------------------------");
      const hasPointsSource = this._map?.getSource('pointsSource');
      try{
        if (hasPointsSource) {
          isStyleFullyLoaded = this._map?.isStyleLoaded() && this._map?.areTilesLoaded() && this._map?.isSourceLoaded('pointsSource');
          // console.log("---estilo 2 si source----", isStyleFullyLoaded, this._map?.isStyleLoaded(), this._map?.areTilesLoaded(), this._map?.isSourceLoaded('pointsSource'));
        } else {
          isStyleFullyLoaded = false;
          // console.log("---estilo 2 no source----");
        }
      }catch(e){
        isStyleFullyLoaded = false;
      }
      // console.log("estilo 3", isStyleFullyLoaded, hasPointsSource, this._map?.isStyleLoaded(), this._map?.areTilesLoaded());
      if (isStyleFullyLoaded && !this.isStyleReady) {
        this.isStyleReady = true;
        this.mainSourceSubject.next({ isMainSourceReady: this.isMainSourceReady, isStyleReady: this.isStyleReady });
      }
    });

    this._map.on('idle', () => {
    if (!this.isStyleReady) {
      this.isStyleReady = true;
      this.mainSourceSubject.next({ 
        isMainSourceReady: this.isMainSourceReady, 
        isStyleReady: this.isStyleReady 
      });
    }
  });

    //marcador en click
    this._map.on('click', (event) => {
      if (this.toolInfoBox.isInfoBoxActive) {
        const { lng, lat } = event.lngLat;
  
        // evitar traslape de click
        const features = this._map.queryRenderedFeatures(event.point);
        const hasSymbolLayer = features.some(feature => 
          this._map.getLayer(feature.layer.id)?.type === 'symbol'
        );
      
        if (hasSymbolLayer) {
          return;
        }
  
        if (this.mapClickMarker) {
          this.mapClickMarker.remove();
        }
  
        this.mapClickMarker = new mapboxgl.Marker({ color: 'red' })
          .setLngLat([lng, lat])
          .addTo(this._map);
  
        // Emitir la nueva ubicación
        this.infoBoxClick.next({ lat, lng });
      }
    });

    if (this.PresentationMode) {
      // this.RunInitialFly(
      //   this.lat.toString(),
      //   this.lng.toString(),
      //   this.zoom.toString()
      // );
      // this.MapHelper.TourCamera(7000);
      // this.MapHelper.FlyToCamera(
      //   this.lat.toString(),
      //   this.lng.toString(),
      //   this.zoom.toString()
      // );
    }
  }

  CreateCustomerLayersHoverEvent(capas: LayerDTO[]) {
    var hoveredMarker = null;
    var popup = new mapboxgl.Popup({});

    capas.forEach((capa) => {
      const showPopup = (e) => {
        const coordinates = (e.features[0].geometry).coordinates.slice();
        const properties = e.features[0].properties;
        console.log("Creating hover event for layer", properties);

        // Obtener ID del marcador
        const marker = properties;
        console.log("markerId", marker, e.features[0]);

        hoveredMarker = marker;

        // Cambiar icono del marcador
        // this._map.setLayoutProperty(capa.name + "-layer", "icon-image", [
        //   "match",
        //   ["get", hoveredMarkerId],
        //   hoveredMarkerId,
        //   capa.icon.replace(".png", "A.png"),
        //   capa.icon,
        // ]);
        // Cambiar texto del marcador
        this._map.setPaintProperty(capa.name + "textLayer", "text-color", [
          "match",
          ["get", "Id"],
          [hoveredMarker.Id], "#0F010F",
          "#530aa8"
        ]);

        var totalProperties = properties.length;
        var propertiesPerColumn = Math.ceil(totalProperties / 2);

        var table = '<table style="width: 100%;"><tbody>';

        // Iterar sobre las propiedades y agregarlas a la tabla en dos columnas
        var count = 0;
        for (const key in properties) {
          const value = properties[key];
          // Si se llenó la primera parte de la tabla, cerrarla y abrir una nueva (de momento, la segunda tabla está directamente abajo de la primera)
          if (count === propertiesPerColumn) {
            table += '</tbody></table><table style="width: 100%;"><tbody>';
          }
          // Agregar la propiedad y su valor como una fila en la tabla
          table += `<tr><td style="border-bottom: 1px solid black; padding-right: 10px;">${key}</td><td style="border-bottom: 1px solid black; padding-left: 10px;">${value}</td></tr>`;
          count++;
        }
        
        table += "</tbody></table>";

        // determina el anchor del popup y el offset según el anchor
        const mapCenter = this._map.getCenter();
        const anchor = coordinates[0] > mapCenter.lng ? "right" : "left";
        const offsetX = anchor === "left" ? 15 : -15;

        // Mostrar el popup con la tabla
        popup = new mapboxgl.Popup({ anchor: anchor, offset: [offsetX, 0], closeButton: false, className: 'table-popup'})
          .setLngLat(coordinates)
          .setHTML(`<h3 style="margin: 0px 30%;">Propiedades</h3>` + table)
          .addTo(this._map);
      };

      const hidePopUp = () => {
        
        // Restaurar icono del marcador solo si hay un marcador bajo el mouse
        if (hoveredMarker) {
          this._map.setLayoutProperty(
            capa.name + "-layerUnclustered",
            "icon-image",
            capa.icon
          );
          this._map.setPaintProperty(
            capa.name + "textLayer",
            "text-color",
            "#530aa8"
          );
          hoveredMarker = null;
        }

        // Cerrar popup si está abierto
        if (popup) {
          popup.remove();
          popup = null;
        }
         
      }

      // Evento mouseenter
      this._map.off("mouseenter", capa.name + "-layerUnclustered", showPopup);
      this._map.off("mouseenter", capa.name + "textLayer", showPopup);
      this._map.on("mouseenter", capa.name + "-layerUnclustered", showPopup);
      this._map.on("mouseenter", capa.name + "textLayer", showPopup);

      // Evento mouseleave
      this._map.off("mouseleave", capa.name + "-layerUnclustered", hidePopUp);
      this._map.off("mouseleave", capa.name + "textLayer", hidePopUp);
      this._map.on("mouseleave", capa.name + "-layerUnclustered", hidePopUp);
      this._map.on("mouseleave", capa.name + "textLayer", hidePopUp);

      
    });
  }

  CreateCategoryLayerEvents(capa: LayerDTO) {
    const defaultCategoryClick = (e) => {
      var obj: any = e.features[0].properties;
      console.log("Objeto Clicked", obj);
      var $identifier: string = e.features[0].properties._Id;
      // var $idLocationCategory: string = e.features[0].properties.IdLocationCategory;
      var $locationCategory: string = e.features[0].properties.LocationCategory;
      console.log("category layer Data", obj, $locationCategory);
      this.panelDetailLocationsService.setCategorySelected($locationCategory);
        setTimeout(() => {
          // this.panelDetailLocationsService.setVisibilityPopup(true);
          this.panelDetailLocationsService.setLoading(true);
        }, 500);
      this.onFocusPin($identifier);
    };

    const popUpCategoryClick = (e) => {
      const obj: any = e.features[0].properties;
      console.log("Objeto Clicked", obj);
      
      const identifier: string = e.features[0].properties._Id;
      const idLocationCategories: number = e.features[0].properties.IdLocationCategory;
      const description: string = e.features[0].properties.Description;
      const date: string = e.features[0].properties._CreatedIn != null && e.features[0].properties._CreatedIn != undefined ? e.features[0].properties._CreatedIn : "Sin datos de fecha";
      const name: string = e.features[0].properties.Name != null && e.features[0].properties.Name != undefined ? e.features[0].properties.Name : "";
      const img: string = e.features[0].properties.LocationCategoryActiveIcon;
      const images = JSON.parse(localStorage.getItem("UrlList"));
      const imgUrl = images.find((x) => x.name === img);

      var title = description != null && description != "..." ? description : identifier;
    
      // Crea el componente dinámicamente y pone estilo
      const componentRef: ComponentRef<CarouselComponent> = this.viewContainerRef.createComponent(CarouselComponent);
      componentRef.instance.identifier = identifier;
      componentRef.instance.idLocationCategory = idLocationCategories;
      const carouselElement = componentRef.location.nativeElement;
      this.renderer.setStyle(carouselElement, 'display', 'flex');
      this.renderer.setStyle(carouselElement, 'height', '100%');
      this.renderer.setStyle(carouselElement, 'max-height', '120px');

      // Contenedor del popup
      const popupContainer = document.createElement('div');
      popupContainer.className = 'popup-container';
      popupContainer.style.position = 'relative';
      popupContainer.style.height = 'auto';
      popupContainer.style.display = 'flex';
      popupContainer.style.flexDirection = 'column';
      popupContainer.style.justifyContent = 'center';
    
      // para crear el carousel
      const carouselContainer = document.createElement('div');
      carouselContainer.style.width = "100%";
      // carouselContainer.style.minHeight = "15px";
      carouselContainer.style.maxHeight = "115px";
      carouselContainer.style.height = "auto";
      carouselContainer.style.overflow = 'hidden'; 
      carouselContainer.style.position = 'relative'; 
      // carouselContainer.style.marginTop = '8px'; 
      carouselContainer.appendChild(carouselElement);
      popupContainer.appendChild(carouselContainer);
    
      // Ttítulo con descripcion y clic
      const titleElement = document.createElement('h3');
      titleElement.innerText = title;
      titleElement.style.margin = '0 0 3px 10px';
      titleElement.style.color = '#3f51b5';
      titleElement.style.overflowX = 'auto';
      titleElement.style.overflowY = 'hidden';
      titleElement.style.maxHeight = '40px';
      titleElement.style.width = '90%';
      titleElement.style.whiteSpace = 'nowrap';
      titleElement.addEventListener('mouseover', () => {
        titleElement.style.color = '#31ab45';
        titleElement.style.textDecoration = 'underline';
        titleElement.style.cursor = 'pointer';
      });
      titleElement.addEventListener('mouseleave', () => {
        titleElement.style.color = '#3f51b5';
        titleElement.style.textDecoration = 'none';
      });
      titleElement.addEventListener('click', () => {
        this.locationsService.setLoading(true);
        this.onFocusPin(identifier);
      });
      popupContainer.appendChild(titleElement);
    
      // descripción flex padre
      const descriptionElement = document.createElement('div');
      descriptionElement.style.height = '50px';
      descriptionElement.style.margin = '0';
      descriptionElement.style.display = 'flex';
      descriptionElement.style.flexDirection = 'row';

      //imagen a la izquierda
      const descriptionImageElement = document.createElement('img');
      descriptionImageElement.style.width = '25%';
      descriptionImageElement.style.objectFit = 'contain'; 
      descriptionImageElement.style.marginRight = '8px'; 
      // descriptionImageElement.style.borderRadius = '4px'; 
      descriptionImageElement.src = imgUrl?.url || ''; 
      descriptionElement.appendChild(descriptionImageElement);

      //flex con datos a la derecha
      const descriptionDataElement = document.createElement('div');
      descriptionDataElement.style.margin = '0';
      descriptionDataElement.style.display = 'flex';
      descriptionDataElement.style.flexDirection = 'column';
      descriptionElement.appendChild(descriptionDataElement);

      //titulo en los datos de la derecha
      const descriptionDataTitleElement = document.createElement('p');
      descriptionDataTitleElement.style.maxHeight = '25px';
      descriptionDataTitleElement.style.overflowX = 'auto';
      descriptionDataTitleElement.style.overflowY = 'hidden';
      descriptionDataTitleElement.style.margin = '0';
      descriptionDataTitleElement.style.whiteSpace = 'nowrap';
      descriptionDataTitleElement.style.fontWeight = 'bold';
      descriptionDataTitleElement.innerText = identifier;
      descriptionDataElement.appendChild(descriptionDataTitleElement);

      //fecha en los datos de la derecha
      const descriptionDataDateElement = document.createElement('p');
      descriptionDataDateElement.style.maxHeight = '25px';
      descriptionDataDateElement.style.overflowX = 'hidden';
      descriptionDataDateElement.style.overflowY = 'hidden';
      descriptionDataDateElement.style.margin = '0';
      descriptionDataDateElement.style.whiteSpace = 'nowrap';
      descriptionDataDateElement.innerText = date;
      descriptionDataElement.appendChild(descriptionDataDateElement);

      //nombre en los datos de la derecha
      const descriptionDataNameElement = document.createElement('p');
      descriptionDataNameElement.style.maxHeight = '25px';
      descriptionDataNameElement.style.overflowX = 'hidden';
      descriptionDataNameElement.style.overflowY = 'hidden';
      descriptionDataNameElement.style.margin = '0';
      descriptionDataNameElement.style.whiteSpace = 'nowrap';
      descriptionDataNameElement.style.fontWeight = 'bold';
      descriptionDataNameElement.innerText = name;
      descriptionDataElement.appendChild(descriptionDataNameElement);

      popupContainer.appendChild(descriptionElement);
    
      // Crear y mostrar el popup
      new mapboxgl.Popup(
        {
          closeButton: true,
          className: 'images-popup'
        }
      )
        .setLngLat(e.lngLat)
        .setDOMContent(popupContainer) // Usar el contenedor con el contenido dinámico
        .addTo(this._map);
    };

    //Se puede hacer dinamico TODO
    if(capa.name.includes("ervicio") || capa.name.includes("ervices")){
      this._map.off("click", capa.name + "-layer", popUpCategoryClick);
      this._map.on("click", capa.name + "-layer", popUpCategoryClick);
    }else{
      this._map.off("click", capa.name + "-layer", defaultCategoryClick);
      this._map.on("click", capa.name + "-layer", defaultCategoryClick);
    }

    var hoveredMarker = null;
    var popup = new mapboxgl.Popup({});

    var categoryMouseEnter = (e) => {
      if (hoveredMarker && hoveredMarker._Id === e.features[0].properties._Id) {
        return;
      }
      const coordinates = (e.features[0].geometry as any).coordinates.slice();

      // Obtener ID del marcador
      const marker = e.features[0].properties;
      console.log("markerId", marker, hoveredMarker, e.features[0]);

      // Almacenar referencia al marcador
      hoveredMarker = marker;

      // Cambiar icono del marcador
      this._map.setLayoutProperty(capa.name + "-layer", "icon-image", [
        "match",
        ["get", "_Id"],
        hoveredMarker._Id,
        capa.icon.replace(".png", "A.png"),
        // capa.icon.replace(".png", "")
        capa.icon
      ]);

      // cambia el color del nombre
      this._map.setPaintProperty(capa.name + "text-layer", "text-color", [
        "match",
        ["get", "_Id"],
        hoveredMarker._Id,
        "#0F010F",
        "#530aa8",
      ]);

      // Mostrar popup y lo guarda en la cariable para despues cerrarlo
      // popup = new mapboxgl.Popup({ offset: [0, -15] })
      //     .setLngLat(coordinates)
      //     .setHTML(`<h3>${nombre}</h3>`)
      //     .addTo(this._map);
    }

    var categoryMouseLeave = () => {
      // Restaurar icono y texto del punto solo si hay un punto bajo el mouse
      if (hoveredMarker) {
        this._map.setLayoutProperty(
          capa.name + "-layer",
          "icon-image",
          // capa.icon.replace(".png", "")
          capa.icon
        );
        this._map.setPaintProperty(
          capa.name + "text-layer",
          "text-color",
          "#530aa8"
        );
        hoveredMarker = null;
      }

      // Cerrar popup si está abierto
      if (popup) {
        popup.remove();
        popup = null;
      }
    }

    // Evento mouseenter
    this._map.on("mouseenter", capa.name + "-layer", categoryMouseEnter);
    this._map.on("mouseenter", capa.name + "text-layer", categoryMouseEnter);

    // Evento mouseleave
    this._map.on("mouseleave", capa.name + "-layer", categoryMouseLeave);
    this._map.on("mouseleave", capa.name + "text-layer", categoryMouseLeave);
  }

  onFocusPin( identifier: any, isRefocus: boolean = false) {
    // this.panelLocationsService.setLoading(true);
      this.panelDetailLocationsService.setVisibilityPopup(true);
      this.panelDetailLocationsService.setLoading(true);
      this.locationsubscription = this.locationsService.getByIdentifier(identifier).subscribe( (data: EstatusJSON) => {
        if (data.isSuccess == true && data.result != null) {
          console.log("PIN SELECTED", data.result);
          this.UpdateDetailLocation(data.result);
          this.CheckAllowBloking(data.result.identifier);
          this.geoClustersFrecuencyCatalogService.setRecurrentPlaces(false);
          this.PinSelected = data.result;

          if (
            this.PinSelected.cordsX != null &&
            this.PinSelected.cordsY != null &&
            this.PinSelected.cordsX != "" &&
            this.PinSelected.cordsY != ""
          ) {
              this.FlyToCamera( this.PinSelected.cordsY, this.PinSelected.cordsX, "15");
            }

            var coords = "No disponible"
            var x = Number(this.PinSelected.cordsX);
            var y = Number(this.PinSelected.cordsY);
            if (typeof y === 'number'  && typeof x === 'number' && !isNaN(y) && !isNaN(x)) {
              coords = y.toFixed(4) + "," + x.toFixed(4);
            }
            this.panelDetailLocationsService.setCoords(coords);
            this.locationsubscription.unsubscribe();
        }else{
          this.notifyService.message("No se encontraron datos relacionados con el activo seleccionado.");
          this.panelDetailLocationsService.setLoading(false);
          this.panelLocationsService.setLoading(false);
          this.locationsService.setLoading(false);
          this.panelDetailLocationsService.setVisibilityPopup(false);
        }
      },
      (error) => {
        this.stopFocusPin();
      }
    );
  }

  stopFocusPin() {
    this.locationsService.setLoading(false);
    this.panelDetailLocationsService.setLoading(false);
    this.locationsubscription.unsubscribe();
  }

  CheckAllowBloking(identifier: string) {
    this.panelDetailLocationsService.setAllowedBloking(false);
    this.citronellaActionsService.getBlokingState(identifier)
      .pipe(first())
      .subscribe((data: EstatusJSON) => {
        if (data.isSuccess) {
          this.panelDetailLocationsService.setAllowedBloking(data.isSuccess);
          this.panelDetailLocationsService.setBlokingIcon(data.result.locked);
        }else{
          this.panelDetailLocationsService.setAllowedBloking(false);
        }
        
      });
  }

  UpdateDetailLocation(Data: any) {
    //debe de llegar el idCategory primero, así que se pone el timeout
    console.log("category Data", Data);
    this.panelDetailLocationsService.setCategorySelected( Data.locationCategory );
    setTimeout(() => {
      this.panelDetailLocationsService.setVisibilityPopup(true);
      this.panelDetailLocationsService.setLoading(true);
      this.panelDetailLocationsService.setGeneralData(Data);
      this.panelDetailLocationsService.setData(Data.data);
      this.GetDirection(Data.cordsY, Data.cordsX).subscribe(direction => {
        // this.popupDetailGeoposService.setAddress(direction);
        this.panelDetailLocationsService.setAddress(direction);
      });
      this.panelDetailLocationsService.setLoading(false);
      this.panelLocationsService.setLoading(false);
      this.locationsService.setLoading(false);
    }, 500);
  }

  onLoadMapGeofences() {
    this._map.on("load", () => {
    
      this.initializeMapGeofences();

      // this._map.on("click", "layer-geofencesPolygons", (e) => {
      //   var obj: any = e.features[0].properties;
      //   console.log("Objeto Clicked");
      //   var $identifier = e.features[0].properties._Id;
      //   console.log($identifier);
      //   //Update Detail Geofence
      //   this.UpdateDetailGeofence($identifier);
      // });

      if (this.PresentationMode) {
        // this.RunInitialFly(
        //   this.lat.toString(),
        //   this.lng.toString(),
        //   this.zoom.toString()
        // );
        // this.MapHelper.TourCamera(7000);
        // this.MapHelper.FlyToCamera(
        //   this.lat.toString(),
        //   this.lng.toString(),
        //   this.zoom.toString()
        // );
      }
    });
  }

  removeAllPolygonDrawControls() {
    this.removeGeofencePolygonDrawControl();
    this.toggleToolMainLayerIntersectDrawControl(false);
    this.toggleToolFilterLayerIntersectDrawControl(false);
  }

  drawIntersectToolPolygon = new MapboxDraw({
    displayControlsDefault: false,
    controls: {
      polygon: false,
      trash: false,
      combine_features: false,
      uncombine_features: false,
      point: false,
    },
  });

  private intersectMainLayerPolygonAreaHandler = (e) => {
    const data = this.drawIntersectToolPolygon.getAll();
    var turfFeaturesInsideArea = this.Empty_GeoJson as FeatureCollection<Point>;
    turfFeaturesInsideArea.features = [];
    if (data.features.length > 0) {
      var area = data.features[0] as any;
      console.log("layers ", this.activeLayers);
        this.activeLayers.forEach((layer) => {
          if (layer.checked){
            var points;
            if (layer.name == "layer-locationsGeneral") {
               points = this._map.getSource("pointsSource")._data;
            }else{
              if (layer.name == "filter-layer-locationsGeneral") {
                 points = this._map.getSource("filterPointsSource")._data;
              }else{
                points = points = this._map.getSource(layer.name + "-source")._data;
              }
            }
              console.log("puntos "+layer.name, points, this.turfHelperService.getPointsWithinPolygon(points, area));
              turfFeaturesInsideArea.features.push(... this.turfHelperService.getPointsWithinPolygon(points, area).features);
          }
          
        });

        console.log("features inside area", turfFeaturesInsideArea);
        var featuresResult = { featureCollection: turfFeaturesInsideArea, destination: EnumFeaturesActionsDestinations.Tool };
        this.featuresInsideArea.next(featuresResult);
        // this.toolCarsSelectorservice.setIntersectedFeatures(this.featuresInsideArea.features);
    } else {
      console.log("features", this.featuresInsideArea);
      this.featuresInsideArea = this.Empty_GeoJson;
      var featuresResult = { featureCollection: turfFeaturesInsideArea, destination: EnumFeaturesActionsDestinations.Tool };
      this.featuresInsideArea.next(featuresResult);
      // this.toolCarsSelectorservice.setIntersectedFeatures(this.featuresInsideArea.features);
    }
  }

  toggleToolMainLayerIntersectDrawControl(activate: boolean) {
    console.log("toggleToolMainLayerIntersectDrawControl", activate);
    
    if (activate) {
      this.removeAllPolygonDrawControls();
      this._map.addControl(this.drawIntersectToolPolygon);

      this._map.on("draw.create", this.intersectMainLayerPolygonAreaHandler);
      this._map.on("draw.delete", this.intersectMainLayerPolygonAreaHandler);
      this._map.on("draw.update", this.intersectMainLayerPolygonAreaHandler);
    } else {
      try {
        this.drawIntersectToolPolygon.deleteAll();
        this._map.off("draw.create", this.intersectMainLayerPolygonAreaHandler);
        this._map.off("draw.delete", this.intersectMainLayerPolygonAreaHandler);
        this._map.off("draw.update", this.intersectMainLayerPolygonAreaHandler);
        this._map.removeControl(this.drawIntersectToolPolygon);
      } catch (error) {}
    }
  }

  private intersectFilterLayerPolygonAreaHandler = (e) => {
    const data = this.drawIntersectToolPolygon.getAll();
    var featuresResult = null;
    var turfFeaturesInsideArea = null;
    if (data.features.length > 0) {
      var area = data.features[0] as any;
      var points = this._map.getSource("filterPointsSource")._data;
      console.log("puntos", points);
      turfFeaturesInsideArea = this.turfHelperService.getPointsWithinPolygon( points, area );
      var features = turfFeaturesInsideArea.features;
      console.log("features", features);
      featuresResult = { featureCollection: turfFeaturesInsideArea, destination: EnumFeaturesActionsDestinations.Tool };
      this.featuresInsideArea.next(featuresResult);
      // this.toolCarsSelectorservice.setIntersectedFeatures(features);
      // this.toolCarsSelectorservice.setAvailabilityButton(true);
    } else {
      turfFeaturesInsideArea = this.Empty_GeoJson;
      console.log("features", turfFeaturesInsideArea);
      featuresResult = { featureCollection: turfFeaturesInsideArea, destination: EnumFeaturesActionsDestinations.Tool };
      this.featuresInsideArea.next(featuresResult);
      // this.toolCarsSelectorservice.setIntersectedFeatures(featuresInsideArea.features);
      // this.toolCarsSelectorservice.setAvailabilityButton(false);
    }
  }

  toggleToolFilterLayerIntersectDrawControl(activate: boolean) {
    console.log("toggleToolFilterLayerIntersectDrawControl", activate);
    if (activate) {
      this.removeAllPolygonDrawControls();
      this._map.addControl(this.drawIntersectToolPolygon);

      this._map.on("draw.create", this.intersectFilterLayerPolygonAreaHandler);
      this._map.on("draw.delete", this.intersectFilterLayerPolygonAreaHandler);
      this._map.on("draw.update", this.intersectFilterLayerPolygonAreaHandler);
    } else {
      try {
        this.drawIntersectToolPolygon.deleteAll();
        this._map.off("draw.create", this.intersectFilterLayerPolygonAreaHandler);
        this._map.off("draw.delete", this.intersectFilterLayerPolygonAreaHandler);
        this._map.off("draw.update", this.intersectFilterLayerPolygonAreaHandler);
        this._map.removeControl(this.drawIntersectToolPolygon);
      } catch (error) {}
    }
  }


  drawGeofencePolygon = new MapboxDraw({
    displayControlsDefault: false,
    controls: {
      polygon: false,
      trash: false,
      combine_features: false,
      uncombine_features: false,
    },
  });

  // toggleDrawControl() {
  //   if (this.AddPolygonGeofenceMode) {
  //     this.addGeofencePolygonDrawControl();
  //   } else {
  //     this.removeGeofencePolygonDrawControl();
  //   }
  // }

  addGeofencePolygonDrawControl(){
    this.removeAllPolygonDrawControls();
    this._map.addControl(this.drawGeofencePolygon);

    this._map.on("draw.selectionchange", this.polygonSelectionChange);
    this._map.on("draw.create", this.updatePolygonArea);
    this._map.on("draw.delete", this.updatePolygonArea);
    this._map.on("draw.update", this.updatePolygonAreaWithConfirmation);
  }

  removeGeofencePolygonDrawControl(){
    try {
      this.drawGeofencePolygon.deleteAll();
      this.isPolygonUpdateConfirmed = false;
      this._map.off("draw.selectionchange", this.polygonSelectionChange);
      this._map.off("draw.create", this.updatePolygonArea);
      this._map.off("draw.delete", this.updatePolygonArea);
      this._map.off("draw.update", this.updatePolygonAreaWithConfirmation);
      this._map.removeControl(this.drawGeofencePolygon);
    } catch (error) {}
  }

  bufferClickHandler = (e) => {
    this.bufferCenterLat = e.lngLat.lat;
    this.bufferCenterLng = e.lngLat.lng;

    this.UpdateActiveBuffer(this.bufferCenterLat, this.bufferCenterLng, this.bufferRadioKm);
    // this.panelAddGeofencesService.setVisibleControlSliderRadio(true);
    
    if (this._map)
      this._map.off("click", this.bufferClickHandler);
  };

  addBufferDrawControl(){
    this.removeBufferDrawControl();
    this._map.on("click", this.bufferClickHandler);
  }

  removeBufferDrawControl(){
    this._map.off("click", this.bufferClickHandler);
  }

  ///control de selector de polígonos
  GeofenceMultiplePolygonSelectionHandler = (e) => {
    if (e.features == null || e.features.length == 0) 
      return;
    const feature = e.features[0];
    const featureId = feature.id;

    const isSelected = this._map.getFeatureState({ source: 'poligonos-selector-source', id: featureId }).selected;
    if (!isSelected) {
      this._map.setFeatureState({ source: 'poligonos-selector-source', id: featureId }, { selected: true });

      var points = this._map.getSource("pointsSource")._data;
      var turfFeaturesInsideArea = this.turfHelperService.getPointsWithinPolygon(points, feature);
      var featuresResult = { featureCollection: turfFeaturesInsideArea, destination: EnumFeaturesActionsDestinations.Geofences };
      this.featuresInsideArea.next(featuresResult);

      this.selectedFeatures.features.push(feature);
      var featuresSelectedResult = { featureCollection: this.selectedFeatures, destination: EnumFeaturesActionsDestinations.Geofences };
      this.featuresSelected.next(featuresSelectedResult);

      console.log("selected features", this.selectedFeatures);
      
    }else{
      this._map.setFeatureState({ source: 'poligonos-selector-source', id: featureId }, { selected: false });
      console.log("antes de filter", this.selectedFeatures);
      
      this.selectedFeatures.features = this.selectedFeatures.features.filter(f => f.id !== featureId);
      var featuresSelectedResult = { featureCollection: this.selectedFeatures, destination: EnumFeaturesActionsDestinations.Geofences };
      this.featuresSelected.next(featuresSelectedResult);
      console.log("selected features", this.selectedFeatures);
    }
  }

  GeofenceSinglePolygonSelectionHandler = (e) => {
    if (e.features == null || e.features.length == 0) 
      return;
    const feature = e.features[0];
    const featureId = feature.id;

    const isSelected = this._map.getFeatureState({ source: 'poligonos-selector-source', id: featureId }).selected;
    if (!isSelected) {
      this.deselectAllZones(EnumFeaturesActionsDestinations.Geofences);
      this._map.setFeatureState({ source: 'poligonos-selector-source', id: featureId }, { selected: true });

      var points = this._map.getSource("pointsSource")._data;
      var turfFeaturesInsideArea = this.turfHelperService.getPointsWithinPolygon(points, feature);
      var featuresResult = { featureCollection: turfFeaturesInsideArea, destination: EnumFeaturesActionsDestinations.Geofences };
      this.featuresInsideArea.next(featuresResult);

      this.selectedFeatures.features.push(feature);
      var featuresSelectedResult = { featureCollection: this.selectedFeatures, destination: EnumFeaturesActionsDestinations.Geofences };
      this.featuresSelected.next(featuresSelectedResult);

      console.log("selected features", this.selectedFeatures);
      
    }else{
      this._map.setFeatureState({ source: 'poligonos-selector-source', id: featureId }, { selected: false });
      console.log("antes de filter", this.selectedFeatures);
      
      this.selectedFeatures.features = this.selectedFeatures.features.filter(f => f.id !== featureId);
      var featuresSelectedResult = { featureCollection: this.selectedFeatures, destination: EnumFeaturesActionsDestinations.Geofences };
      this.featuresSelected.next(featuresSelectedResult);
      console.log("selected features", this.selectedFeatures);
    }
  }

  hoveredPolygonId = null;

  polygonHoverStatesHandler = (e) => {
    if (e.features == null || e.features.length == 0) 
      return;

    if (e.features[0] != null && e.features[0].layer.id != 'layer-poligonos-Selector') 
      return;

    // console.log("hover polygon", e.features[0], this.hoveredPolygonId);
    if(this.hoveredPolygonId != null)
      this._map.setFeatureState({ source: 'poligonos-selector-source', id: this.hoveredPolygonId }, { hover: false });
    
    const feature = e.features[0];
    this.hoveredPolygonId = feature.id;
    // console.log("hover polygon 2", feature, this.hoveredPolygonId);

    this._map.getCanvas().style.cursor = 'pointer';
    this._map.setFeatureState({ source: 'poligonos-selector-source', id: this.hoveredPolygonId }, { hover: true });
    // this._map.setFeatureState({ source: 'poligonos-selector-source', sourceLayer: 'layer-poligonos-Selector', id: featureId }, { hover: true });
  }

  polygonUnhoverStatesHandler = (e) => {
    if (this.hoveredPolygonId == null) 
      return;
    this._map.getCanvas().style.cursor = '';
    this._map.setFeatureState({ source: 'poligonos-selector-source', id: this.hoveredPolygonId }, { hover: false });
    this.hoveredPolygonId = null;
  }

  addMapZoneSelector(destination: string){
    if(destination == EnumFeaturesActionsDestinations.Geofences){
      this.removeMapZoneSelector(destination);
      this._map.on('click', 'layer-poligonos-Selector', this.GeofenceSinglePolygonSelectionHandler);
        
      // this._map.on('mouseenter', 'layer-poligonos-Selector', this.polygonHoverStatesHandler);
      this._map.on('mousemove', 'layer-poligonos-Selector', this.polygonHoverStatesHandler);
      this._map.on('mouseleave', 'layer-poligonos-Selector', this.polygonUnhoverStatesHandler);
    }
  }

  removeMapZoneSelector(destination: string){
    if(destination == EnumFeaturesActionsDestinations.Geofences){
      this.deselectAllZones(destination);
      this._map.off('click', 'layer-poligonos-Selector', this.GeofenceSinglePolygonSelectionHandler);
      this._map.off('mouseenter', 'layer-poligonos-Selector', this.polygonHoverStatesHandler);
      this._map.off('mouseleave', 'layer-poligonos-Selector', this.polygonUnhoverStatesHandler);
    }
  }

  selectZoneByProperty(key: string, value: string, destination: string){
    if (!this._map.getLayer('layer-poligonos-Selector'))
      return;
    // const features = this._map.querySourceFeatures('poligonos-selector-source', { sourceLayer: 'layer-poligonos-Selector' });
    // const features = this._map.queryRenderedFeatures({ layers: ['layer-poligonos-Selector'] });
    const features = this.getLayerFeatures('layer-poligonos-Selector');
    const featureFiltered = features.find(f => f.properties && f.properties[key] === value);
    if (featureFiltered != null){
      this._map.setFeatureState({ source: 'poligonos-selector-source', id: featureFiltered.id }, { selected: true });
      this.selectedFeatures.features.push(featureFiltered);
      var featuresSelectedResult = { featureCollection: this.selectedFeatures, destination: destination };
      this.featuresSelected.next(featuresSelectedResult);
    }
  }

  selectAllZones(destination: string){
    if (!this._map.getLayer('layer-poligonos-Selector')) 
      return;

    // const features = this._map.queryRenderedFeatures({ layers: ['layer-poligonos-Selector'] });
    // const features = this._map.querySourceFeatures('poligonos-selector-source', { sourceLayer: 'layer-poligonos-Selector' });
    const features = this.getLayerFeatures('layer-poligonos-Selector');
    
    features.forEach((feature) => {
      const featureId = feature.id;
      this._map.setFeatureState({ source: 'poligonos-selector-source', id: featureId }, { selected: true });
    });
    this.selectedFeatures = { type: 'FeatureCollection', features: features };
    var featuresSelectedResult = { featureCollection: this.selectedFeatures, destination: destination };
    this.featuresSelected.next(featuresSelectedResult);
  }

  deselectAllZones(destination: string){
    if (!this._map.getLayer('layer-poligonos-Selector')) 
      return;
    // const features = this._map.querySourceFeatures('poligonos-selector-source', { sourceLayer: 'layer-poligonos-Selector' });
    // const features = this._map.queryRenderedFeatures({ layers: ['layer-poligonos-Selector'] });
    const features = this.getLayerFeatures('layer-poligonos-Selector');
    features.forEach((feature) => {
      const featureId = feature.id;
      this._map.setFeatureState({ source: 'poligonos-selector-source', id: featureId }, { selected: false });
    });
    this.selectedFeatures = { type: 'FeatureCollection', features: [] };
    var featuresSelectedResult = { featureCollection: this.selectedFeatures, destination: destination };
    this.featuresSelected.next(featuresSelectedResult);
  }

  getLayerFeatures(layerId: string) : any {
    const renderedFeatures = this._map.queryRenderedFeatures({ layers: [layerId] });
  
    //elimina duplicados con el array y despues obtiene los values
    const uniqueFeatures = [ ...new Map(renderedFeatures.map(f => [f.id, f])).values() ];
    // console.log("getLayerFeatures", renderedFeatures, uniqueFeatures);
    
    return uniqueFeatures;
  }


  getpolygonPointsCentroid(polygonPoints: any[][]) {
    const coordinates = this.turfHelperService.getCentroidGeoJSON(polygonPoints).geometry.coordinates;
    return coordinates;
  }

  getpolygonCentroid(feature: any) {
    const newFeature = this.turfHelperService.getFeatureCentroidGeoJSON(feature);
    return newFeature;
  }

  updatePolygonArea = (e) => {
    const data = this.drawGeofencePolygon.getAll();
    if (data.features.length > 0) {
      var polygon = data.features[0] as any;
      const coordinates = polygon.geometry.coordinates[0];
      // mete las coordenadas en el arreglo
      this.polygonPoints = coordinates;

      var points = this._map.getSource("pointsSource")._data;
      console.log("puntos", points);

      var turfFeaturesInsideArea = this.turfHelperService.getPointsWithinPolygon(points, polygon);
      var features = turfFeaturesInsideArea.features;
      console.log("features", turfFeaturesInsideArea, features);
      var featuresResult = { featureCollection: turfFeaturesInsideArea, destination: EnumFeaturesActionsDestinations.Geofences };
      this.featuresInsideArea.next(featuresResult);

      // this.panelAddGeofencesService.setIntersectedFeatures(features);
    } else {
      this.polygonPoints = [];
    }
  }

  updatePolygonAreaWithConfirmation = async (e) => {
    if (!this.isPolygonUpdateConfirmed){
      const resp = await this.swalNotificationService.confirmMessage("¿Deseas modificar el área de la geocerca?", 'Se actualizarán los puntos que se encuentran dentro de la geocerca.');
      if (!resp.isConfirmed){
        this.drawGeofencePolygon.set(this.originalGeofencePolygonDrawData);
        return;
      }
      this.isPolygonUpdateConfirmed = true;
    }

    const data = this.drawGeofencePolygon.getAll();
    if (data.features.length > 0) {
      var polygon = data.features[0] as any;
      const coordinates = polygon.geometry.coordinates[0];
      // mete las coordenadas en el arreglo
      this.polygonPoints = coordinates;

      var points = this._map.getSource("pointsSource")._data;
      console.log("puntos", points);

      var turfFeaturesInsideArea = this.turfHelperService.getPointsWithinPolygon(points, polygon);
      var features = turfFeaturesInsideArea.features;
      console.log("features", turfFeaturesInsideArea, features);
      var featuresResult = { featureCollection: turfFeaturesInsideArea, destination: EnumFeaturesActionsDestinations.Geofences };
      this.featuresInsideArea.next(featuresResult);

      // this.panelAddGeofencesService.setIntersectedFeatures(features);
    } else {
      this.polygonPoints = [];
    }
  }

  polygonSelectionChange = (e) => {
    if (e.features.length > 0) {
      this.originalGeofencePolygonDrawData = this.drawGeofencePolygon.getAll();
    }
  }

  UpdateDetailGeofence($identifier: any) {
    this.panelGeofencesService.setLoading(true);
    this.geofenceService.get($identifier).subscribe((data: EstatusJSON) => {
      if (data.isSuccess == true) {
        this.panelGeofencesService.setLoading(false);
        console.log("PIN SELECTED");
        // this.panelLocationsService
        this.geofenceService.setVisiblePanelDetailGeofences(true);
        this.panelDetailGeofencesService.setVisibilityPopup(true);
        this.panelDetailGeofencesService.setTitle(data.result.name);
        this.panelDetailGeofencesService.setSubtitle("Detalle de Geocerca");
        this.panelDetailGeofencesService.setData(data.result.data);
        this.PinSelected = data.result;
        this.FlyToCameraFast(
          this.PinSelected.geom_CentroidY,
          this.PinSelected.geom_CentroidX,
          "9"
        );
      }
    });

    // this.panelDetailGeofencesService.setLastUpdate(Data.createdIn);
  }

  public AddMarkerActive(lngLat) {
    //  this.ClearLayerActive();
    //   // adding
    //   const marker = new mapboxgl.Marker().setLngLat(lngLat).addTo(this._map);
    //   this.mapMarkers.push(marker);
  }

  ClearLayerActive() {
    // removing
    this.mapMarkers.forEach((marker) => marker.remove());
    this.mapMarkers = [];
  }
  initializeMapLocations() {
    var locationCategories = JSON.parse(localStorage.getItem("listaCategorias")) as LocationCategoryDTO[];
    this.AddMapboxPlaces();
    // this._map.setLayoutProperty('state-label', 'visibility', 'visible');
    // this._map.setLayoutProperty('traffic', 'visibility', 'false');
    // this._map.setLayoutProperty('road-labels', 'visibility', 'visible');
    // this.AddSourceEmptyGeoJson("locationCarActiveSource");
    // this.AddSourceEmptyGeoJson("locationEngineerActiveSource");
    // this.AddSourceEmptyGeoJson("locationServiceActiveSource");
    // this.AddSourceEmptyGeoJson("locationBussineActiveSource");
    // this.AddSourceEmptyGeoJson("locationCarrierActiveSource");
    this.AddSourceEmptyGeoJson("routeLocationRelatedSource");
    this.AddSourceEmptyGeoJson("locationRelatedSource");

    this.AddSourceEmptyGeoJson("routeToRouteSheetPointSource");
    this.AddSourceEmptyGeoJson("routeSheetLocationsSource-Services");
    this.AddSourceEmptyGeoJson("routeSheetLocationsSource-Unit");
    this.AddSourceEmptyGeoJson("routeSheetLocationsSource-Location");

    this.AddSourceClusteredEmptyGeoJson("pointsSource");
    this.AddSourceClusteredEmptyGeoJson("filterPointsSource");

    this.AddSourceEmptyGeoJson("serviceAssignmentRegionsSource");
    this.AddSourceEmptyGeoJson("serviceAssignmentZonesSource");
    this.AddSourceEmptyGeoJson("serviceAssignmentClustersSource");
    // this.AddSourceClusteredEmptyGeoJson("serviceAssignmentClustersSource");
    this.AddSourceEmptyGeoJson("serviceAssignmentFinishedEngineerSource");
    this.AddSourceEmptyGeoJson("serviceAssignmentFinishedServiceSource");

    this.AddBaseMapSatellite();
    //para filtro de puntos
    this.AddLayerCluster("filter-clusters", "filterPointsSource");
    this.AddLayerClusterCount("filter-cluster-count", "filterPointsSource");
    this.AddLayerText("filter-layer-pinText", "filterPointsSource", "_Id", -2);

    this.AddLayerCluster("clusters", "pointsSource");
    this.AddLayerClusterCount("cluster-count", "pointsSource");
    this.AddLayerText("layer-pinText", "pointsSource", "_Id", -2.2);

    this.ShowHideLayer("satellite-layer");
    this.ShowHideLayer("satellite-layer");

    this.AddLayerLocationsGeneral("filter-layer-locationsGeneral", "filterPointsSource", 'LocationCategoryIcon', this.generalMapIconSize);
    this.AddLayerLocationsGeneral("layer-locationsGeneral", "pointsSource", 'LocationCategoryIcon', this.generalMapIconSize);

    console.log("listaCategorias categories", locationCategories);
    locationCategories.forEach((category) => {
      this.AddSourceEmptyGeoJson("location"+category.name+"ActiveSource");
      this.AddLayerLocationActive("layer-location"+category.name+"Active", "location"+category.name+"ActiveSource", category.activeIcon, this.generalMapIconSize);
    });

    // para ver su click, buscar la funcion CategoryPopUpMouseOver en el onloadMapLocations --- todo: revisar el icono
    this.AddLayerText( "layer-LocationRelated-PinText", "locationRelatedSource", "IdentifierChild", -2 );
    this.AddLayerLocationsGeneral("layer-LocationRelated", "locationRelatedSource", 'Icon', this.generalMapIconSize, true);
    this.AddLayerLine( "layer-LocationRelatedRoute", "routeLocationRelatedSource" );

    //su funcion de click es igual a location related, pero es exclusivo de route sheet
    this.AddDirectionLine( "layer-RouteSheetRoute-Services", "routeSheetRouteSource-Services" );
    this.AddDirectionLine( "layer-RouteSheetRoute-Unit", "routeSheetRouteSource-Unit" );
    this.AddDirectionLine( "layer-RouteSheetRoute-Location", "routeSheetRouteSource-Location" );
    this.AddLayerLine( "layer-RouteSheetRouteToPoint", "routeToRouteSheetPointSource", "#354F84" );
    // para route sheet servicios
    this.AddLayerText( "layer-RouteSheetLocations-Services-PinText", "routeSheetLocationsSource-Services", "IdentifierChild", -2);
    this.AddLayerLocationsGeneral("layer-RouteSheetLocations-Services", "routeSheetLocationsSource-Services", "Icon", this.generalMapIconSize, true);
    // para routesheet unidades
    this.AddLayerText( "layer-RouteSheetLocations-Unit-PinText", "routeSheetLocationsSource-Unit", "IdentifierChild", -2);
    this.AddLayerLocationsGeneral("layer-RouteSheetLocations-Unit", "routeSheetLocationsSource-Unit", "Icon", this.generalMapIconSize, true);
    // para routesheet locations
    this.AddLayerText( "layer-RouteSheetLocations-Location-PinText", "routeSheetLocationsSource-Location", "IdentifierChild", -2);
    this.AddLayerLocationsGeneral("layer-RouteSheetLocations-Location", "routeSheetLocationsSource-Location", "Icon", this.generalMapIconSize, true);

    //para ver las areas de asignacion de servicios
    this.AddLayerCustomizablePolygons( "layer-serviceAssignmentRegions", "serviceAssignmentRegionsSource", 0.3, "#3410ff", 22, 0);
    this.AddLayerLine( "layer-line-serviceAssignmentRegions", "serviceAssignmentRegionsSource", "#1900a7", 3);
    this.AddLayerCustomizablePolygons( "layer-serviceAssignmentZones", "serviceAssignmentZonesSource", 0.6, "#3e9be7", 22, 0);
    this.AddLayerLine( "layer-line-serviceAssignmentZones", "serviceAssignmentZonesSource",  "#00274b", 3);
    this.AddLayerCustomizablePolygons( "layer-serviceAssignmentClusters", "serviceAssignmentClustersSource",0.8, "#b60000", 22, 0);
    this.AddLayerLine( "layer-line-serviceAssignmentClusters", "serviceAssignmentClustersSource", "#840000", 3);
    this.AddLayerIcon("layer-serviceAssignmentFinishedEngineer", "serviceAssignmentFinishedEngineerSource", "engineerAssigned.png", 0.1);
    this.AddLayerIcon("layer-serviceAssignmentFinishedService", "serviceAssignmentFinishedServiceSource", "service.png", 0.15);
    //crea punto central
    this.AddSourceEmptyGeoJson("centerPointSource");
    this.addLayerCenterPoint('centerPoint-layer','centerPointSource');
  }



  initializeMapGeofences() {
    //sources para geocercas
    this.AddSourceEmptyGeoJson("recurrentPlacesSource");
    this.AddSourceEmptyGeoJson("bufferActiveSource");
    this.AddSourceEmptyGeoJson("bufferActiveValetParkingSource");
    this.AddSourceEmptyGeoJson("PolygonActiveSource");
    this.AddSourceEmptyGeoJson("poligonos-selector-source");
    this.AddSourceEmptyGeoJson("geofencesSource");
    this.AddSourceHighEmptyGeoJson("Geocercas-highSource");
    this.AddSourceClusteredEmptyGeoJson("locationsSource");
    this.AddBaseMapSatellite();

    //layers normales para geocercas
    this.AddLayerBufferRecurrent("layer-recurrentPlaces","recurrentPlacesSource", EnumBufferTypes.Default);
    this.AddLayerBufferActive("layer-bufferActive", "bufferActiveSource", EnumBufferTypes.Default);
    this.AddLayerBufferActive("layer-bufferActiveValetParking", "bufferActiveValetParkingSource", EnumBufferTypes.Valet_Parking);
    this.AddLayerGeofencesPolygons( "layer-polygonActive", "PolygonActiveSource");

    //layers con clusters
    var layer: mapboxgl.Layer = this._map.getLayer( "clustersGeofences" ) as mapboxgl.Layer;
    if (layer === undefined) {
      this.AddLayerCluster("clustersGeofences", "locationsSource");
    }
    this.AddLayerUnclusteredPoints("layer-points-g", "locationsSource");

    //layers con estados
    this.AddLayerGeofencesPolygonsWithFeatureStatus( "layer-poligonos-Selector", "poligonos-selector-source");
    this.AddLayerLine( "layer-line-poligonos-Selector", "poligonos-selector-source", "#352F84", 3);

    //layers de texto
    this.AddLayerText("layer-pinText-g", "locationsSource", "_Id", -4);
    this.AddLayerText("layer-recurrentPlacesText", "recurrentPlacesSource", "Name", -4);
    this.AddLayerText("layer-poligonos-SelectorText", "poligonos-selector-source", "NOMGEO", -1);
    this.ShowHideLayer("satellite-layer");
    this.ShowHideLayer("satellite-layer");
  }

  AddMapboxPlaces() {
    if (window.innerWidth >= 750) {
      this.geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl: mapboxgl,
        placeholder: "Búsqueda por Dirección",
      });
      // Add the control to the map.
      this._map.addControl(this.geocoder);
    }
  }

  RemoveMapboxPlaces() {
    // remueve el geocoder
    this._map.removeControl(this.geocoder);
    this.geocoder = null;
  }

  onLoadMapRoutes() {
    this._map.on("load", () => {
      // this._map.loadImage("/assets/img/pinGeoposition.png", (error, image) => {
      //   if (error) throw error;
      //   if (!this._map.hasImage("pinGeoposition"))
      //     this._map.addImage("pinGeoposition", image, { sdf: true });
      // });
      this._map.loadImage("/assets/img/starting.png", (error, image) => {
        if (error) throw error;
        if (!this._map.hasImage("starting"))
          this._map.addImage("starting", image, { sdf: false });
      });
      this._map.loadImage("/assets/img/parking.png", (error, image) => {
        if (error) throw error;
        if (!this._map.hasImage("parking"))
          this._map.addImage("parking", image, { sdf: false });
      });
      this._map.loadImage("/assets/img/moving.png", (error, image) => {
        if (error) throw error;
        if (!this._map.hasImage("moving"))
          this._map.addImage("moving", image, { sdf: false });
      });

      this.initializeMapRoutes();

      this._map.on("click", "routeResume-steps-layer", (e) => {
        var obj: any = e.features[0].properties;
        console.log("Objeto Clicked");
        console.log(e.features[0]);
        this.popupDetailGeoposService.setVisibilityPopup(true);
        this.popupDetailGeoposService.setData(e.features[0].properties);
        this.popupDetailGeoposService.setTitle(e.features[0].properties._Id);
        this.popupDetailGeoposService.setLastUpdate(
          e.features[0].properties._CreatedIn
        );
        this.GetDirection(
          e.features[0].properties._Longitude,
          e.features[0].properties._Latitude
        ).subscribe(direction => {
          this.popupDetailGeoposService.setAddress(direction);
          this.panelDetailLocationsService.setAddress(direction);
        });
      });

      //   _map.on("click", "startEndPoints-layer", (e) => {
      //     var obj: any = e.features[0].properties;
      //     console.log("Objeto Clicked");
      //     console.log(obj);
      //     this.popupDetailGeoposService.setVisibilityPopup(true);
      //     this.popupDetailGeoposService.setData(e.features[0].properties);
      //     this.popupDetailGeoposService.setTitle(e.features[0].properties._Id);
      //     this.popupDetailGeoposService.setLastUpdate(e.features[0].properties._CreatedIn);
      //     this.GetDirection(e.features[0].properties._Longitude,e.features[0].properties._Latitude);
      // });
    });
  }
  // if (this.PresentationMode) {
  //   this.MapHelper.InitialFly(
  //     this.lat.toString(),
  //     this.lng.toString(),
  //     this.zoom.toString()
  //   );
  //   this.MapHelper.TourCamera(7000);
  //   this.MapHelper.FlyToCamera(
  //     this.lat.toString(),
  //     this.lng.toString(),
  //     this.zoom.toString()
  //   );
  // }

  GetDirection(x, y): Observable<string> {
    return this.GetDirectionByCoords(x, y).pipe(
      map((data: EstatusJSON) => data.isSuccess ? data.result : "Dirección no disponible"),
      catchError(error => {
        console.log("Servicio de Direcciones no disponible, inténtelo más tarde");
        return of("Dirección no disponible");
      })
    );
  }

  GetDirectionByCoords(_Latitude: any, _Longitude: any): any {
    console.log(
      this.configUrl +
        "/api/RouteMap/GetDirectionByCoords?x=" +
        _Latitude +
        "&y=" +
        _Longitude
    );
    return this.http.get<EstatusJSON>(
      this.configUrl +
        "/api/RouteMap/GetDirectionByCoords?x=" +
        _Latitude +
        "&y=" +
        _Longitude
    );
  }

  UpdateActiveLocation(obj: { lat: number; lng: number, idntf: string, idLocationCategory: number, locationCategory: string }) {
    var jsonf = {
      type: "FeatureCollection",
      features: [
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [obj.lng, obj.lat],
          },
          properties: {
            title: "test",
            _Id: obj.idntf,
          },
        },
      ],
    };

    this.UpdateLayerGeoJson("location"+obj.locationCategory+"ActiveSource", jsonf);
    this.MoveLayerToTop("layer-location"+obj.locationCategory+"Active");
    // this.MoveLayer("layer-location"+obj.locationCategory+"Active", "layer-locationsGeneral");
  }

  UpdateActivePoint(lat: number, lng: number, layerName: string) {
    console.log("[UPDATE ACTIVE POINT] - BUFFER");
    var jsonf = {
      type: "FeatureCollection",
      features: [
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [lng, lat],
          },
          properties: {
            title: "test",
          },
        },
      ],
    };
    this.UpdateLayerGeoJson(layerName, jsonf);
  }

  UpdateActiveBuffer(lat: number, lng: number, radioKm: number) {
    console.log("[UPDATE ACTIVE BUFFER] - BUFFER", lat, lng, radioKm);
    
    this.bufferCenterLat = lat;
    this.bufferCenterLng = lng;

    this.UpdateActivePoint(this.bufferCenterLat, this.bufferCenterLng, "bufferPointActiveSource");
    var buffer = this.turfHelperService.getBufferGeoJSON(lat, lng, radioKm);
    this.FitBounds(buffer.geometry);
    this.UpdateLayerGeoJson("bufferActiveSource", buffer);
    var points = this._map.getSource("pointsSource")._data;
    var turfFeaturesInsideArea = this.turfHelperService.getPointsWithinPolygon( points, buffer );
    var features = turfFeaturesInsideArea.features;
    console.log("features", features);
    var featuresResult = { featureCollection: turfFeaturesInsideArea, destination: EnumFeaturesActionsDestinations.Geofences };
    this.featuresInsideArea.next(featuresResult);
    // this.panelAddGeofencesService.setIntersectedFeatures(features);
  }

  ResetActiveBuffer() {
    this.UpdateActivePoint(this.bufferCenterLat, this.bufferCenterLng, "bufferPointActiveSource");
    this.UpdateLayerGeoJson("bufferActiveSource", this.Empty_GeoJson);
  }

  ResetValetOParkingActiveBuffer() {
    this.UpdateActivePoint(this.bufferCenterLat, this.bufferCenterLng, "bufferPointActiveSource");
    this.UpdateLayerGeoJson("bufferActiveValetParkingSource", this.Empty_GeoJson);
  }

  initializeMapRoutes() {
    // this.AddSourceEmptyGeoJson("points");
    // this.AddSourceEmptyGeoJson("route");
    this.AddSourceEmptyGeoJson("routeResume");
    this.AddSourceEmptyGeoJson("routeGroupStep");
    this.AddSourceEmptyGeoJson("routeResumeOpacityMin");
    // this.AddSourceEmptyGeoJson("startEndPoints");
    // this.AddSourceClusteredEmptyGeoJson("LastGeoPositions");
    this.AddBaseMapSatellite();
    // this.AddLayerIcon("cars-layer", "LastGeoPositions", "car");
    // this.AddLayerCluster("clusters", "LastGeoPositions");
    // this.AddLayerClusterCount("cluster-count", "LastGeoPositions");
    // this.AddLayerLine("realRoute-layer", "realRoute");
    this.AddLayerTextH3WithStatus(
      "routeResume-steps-textlayer",
      "routeResume",
      "Id"
    );
    // this.AddLayerTextH3("routeStepsGroup-steps-textlayer", "routeResume","Id");
    this.AddLayerLine("routeResume-line-layer", "routeResume");
    this.AddLayerLineBold("routeStepsGroup-line-layer", "routeGroupStep");
    this.AddLayerLineOpacityMin(
      "routeResume-lineOpacityMin-layer",
      "routeResumeOpacityMin"
    );
    this.AddLayerSteps("routeResume-steps-layer", "routeResume");
    // this.AddLayerGeoPoints("points-layer", "points");
    // this.AddLayerStartEndPoints("startEndPoints-layer", "startEndPoints");
    this.ShowHideLayer("satellite-layer");
    this.ShowHideLayer("satellite-layer");
    this.ShowHideLayer("routeResume-lineOpacityMin-layer");
  }
  AddLayerLineDashed(id: string, source: string) {
    this._map.addLayer({
      id: id,
      type: "line",
      source: source,
      layout: {
        "line-join": "round",
        "line-cap": "round",
      },
      paint: {
        "line-color": "#352F84",
        "line-dasharray": [2, 1],
        "line-width": 5,
        "line-opacity": 0.85,
      },
    });
  }
  AddLayerLine(id: string, source: string, lineColor: string = "#352F84", lineWidth: number = 5) {
    this._map.addLayer({
      id: id,
      type: "line",
      source: source,
      layout: {
        "line-join": "round",
        "line-cap": "round",
        visibility: "visible",
      },
      paint: {
        "line-color": lineColor,
        "line-width": lineWidth,
        "line-opacity": 0.75,
      },
    });
  }
  
  AddDirectionLine(id: string, source: string, lineColor: string = "#7c1779") {
    this.AddSourceEmptyGeoJson(source);
    this.AddSourceEmptyGeoJson(source+ "-Start");
    this.AddSourceEmptyGeoJson(source+ "-End");
    this.AddSourceEmptyGeoJson(source+"-Dialog");

    this._map.addLayer({
      id: id + "-background",
      type: "line",
      source: source,
      layout: {
        "line-join": "round",
        "line-cap": "round",
        visibility: "visible",
      },
      paint: {
        "line-color": "#fff",
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10, 5,
          15, 6,
          18, 10
        ],
        "line-opacity": 0.8,
      },
    });
  
    this._map.addLayer({
      id: id,
      type: "line",
      source: source,
      layout: {
        "line-join": "round",
        "line-cap": "round",
        visibility: "visible",
      },
      paint: {
        "line-color": lineColor,
        // "line-gradient": [
        //   "interpolate",
        //   ["linear"],
        //   ["line-progress"],
        //   0, "#972BFB",
        //   1, "#7A49FF"
        // ],
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10, 3,
          15, 5,
          18, 8
        ],
        "line-opacity": 1,
      },
    });
  
    this._map.addLayer({
      id: id + "-arrows",
      type: "symbol",
      source: source,
      layout: {
        "symbol-placement": "line",
        "symbol-spacing": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10, 5,
          15, 10,
          18, 20
        ],
        "icon-image": "white-arrow.png",
        "icon-size": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10, 0.04,
          15, 0.025,
          18, 0.032
        ],
        "icon-rotation-alignment": "map",
        "icon-pitch-alignment": "map",
        // "icon-rotate": 90,
        "icon-allow-overlap": true,
        "icon-ignore-placement": true,
      },
      paint: {
      "icon-opacity": 1.0
      }
    });

    this._map.addLayer({
      id: id + "-start-pin-pulse",
      type: "symbol",
      source: source + "-Start",
      layout: {
        "icon-image": "startPoint-pulse",
        "icon-size": 0.6,
        "icon-anchor": "top",
        "icon-allow-overlap": true,
        "icon-ignore-placement": true,
        "icon-pitch-alignment": "map",
        "icon-rotation-alignment": "map",
        "icon-offset": [-2, -22],
      },
      paint: {
        "icon-opacity": 0.7
      }
    });

    // Pin de inicio
    this._map.addLayer({
      id: id + "-start-pin",
      type: "symbol",
      source: source+"-Start",
      layout: {
        "icon-image": "startPoint.png",
        "icon-size": 0.06011,
        "icon-offset": [0, -10],
        "icon-anchor": "top",
        "icon-allow-overlap": true,
        "icon-ignore-placement": true,
        "icon-pitch-alignment": "map",
        "icon-rotation-alignment": "map",
      },
      paint: {
        "icon-opacity": 1.0
      }
    });
  
    // Pin de llegada  
    this._map.addLayer({
      id: id + "-end-pin",
      type: "symbol",
      source: source+ "-End",
      layout: {
        "icon-image": "endPoint-flag.png",
        // "icon-size": 0.20,
        "icon-size": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10, 0.2,
          15, 0.2,
          18, 0.00
        ],
        "icon-anchor": "bottom",
        "icon-offset": [-1, -10],
        "icon-allow-overlap": true,
        "icon-ignore-placement": true,
      },
      paint: {
        "icon-opacity": 1.0
      }
    });
  
    // Texto al lado de la ruta (de momento no)
    this._map.addLayer({
      id: id + "-route-label",
      type: "symbol",
      source: source,
      layout: {
        "symbol-placement": "point",
        "symbol-spacing": 999999, 
        "text-field": "", 
        "text-font": ["Open Sans Bold", "Arial Unicode MS Bold"],
        "text-size": 14,
        "text-anchor": "center",
        "icon-pitch-alignment": "viewport",
        "icon-rotation-alignment": "viewport",
        "text-offset": [0, -2],
        "text-justify": "center"
      },
      paint: {
      "text-color": "#fff",
      "text-halo-color": "#7C3AED",
      "text-halo-width": 8
    }
    });

    this._map.addLayer({
      id: id + "-dialog",
      type: "symbol",
      source: source + "-Dialog",
      layout: {
        "icon-image": "routeBalloon-offCenter.png",
        "icon-size": 0.10,
        "icon-anchor": "center",
        "icon-allow-overlap": true,
        "icon-ignore-placement": true
      },
      paint: {
        "icon-opacity": 0
      }
    });

    this._map.addLayer({
      id: id + "-dialog-text",
      type: "symbol",
      source: source + "-Dialog",
      layout: {
        "text-field": ["get", "RTA"],
        "text-font": ["Open Sans Bold", "Arial Unicode MS Bold"],
        "text-size": 10,
        "text-anchor": "center",
        "text-allow-overlap": true,
        "text-ignore-placement": true,
        "text-offset": [1.5, -4],
        "text-max-width": 6
      },
      paint: {
        "text-color": "#fff",
        // "text-halo-color": "#000",
        "text-halo-width": 2,
        "icon-opacity": 0
      }
    });
    
  }


  AddLayerLineBold(id: string, source: string) {
    this._map.addLayer({
      id: id,
      type: "line",
      source: source,
      layout: {
        "line-join": "round",
        "line-cap": "round",
        visibility: "visible",
      },
      paint: {
        "line-color": "#b805ff",
        "line-dasharray": [2, 1],
        "line-width": 8,
        "line-opacity": 0.85,
      },
    });
  }

  AddLayerLineOpacityMin(id: string, source: string) {
    this._map.addLayer({
      id: id,
      type: "line",
      source: source,
      layout: {
        "line-join": "round",
        "line-cap": "round",
        visibility: "visible",
      },
      paint: {
        "line-color": "#3887be",
        "line-width": 7,
        "line-opacity": 0.35,
      },
    });
  }

  AddLayerSteps(id: string, source: string) {
    this._map.addLayer({
      id: id,
      type: "symbol",
      source: source,
      maxzoom: 22,
      layout: {
        "icon-allow-overlap": true,
        "icon-image": [
          "case",
          ["==", ["get", "StatusVehicle"], "Encendido"], // Si Status es igual a 1
          "starting", // Usar el icono "fence"
          ["==", ["get", "StatusVehicle"], "Apagado"], // Si Status es igual a 1
          "parking",
          ["==", ["get", "StatusVehicle"], "Moviendo"], // Si Status es igual a 1
          "moving",
          "", // Si no coincide con 1 ni con 0, no se muestra ningún icono
        ],
        "icon-size": 0.15,
      },
    });
  }

  AddLayerGeoPoints(id: string, source: string) {
    this._map.addLayer({
      id: id,
      type: "symbol",
      source: source,
      layout: {
        "icon-image": "pinGeoposition",
        "icon-size": 0.15,
        "text-field": ["get", "_NoOrder"],
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": [0, 1.25],
        "text-anchor": "top",
      },
      paint: {
        "icon-color": [
          "match", // Use the 'match' expression: https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-match
          ["get", "_IconValue"], // Use the result 'STORE_TYPE' property
          "1",
          "#008000",
          "2",
          "#FF0000",
          "#f5290a", // any other store type
        ],
      },
    });
  }

  AddLayerStartEndPoints(id: string, source: string) {
    this._map.addLayer({
      id: id,
      type: "symbol",
      source: source,
      layout: {
        "icon-image": "pin",
        "icon-size": 0.3,
        "text-field": ["get", "_NoOrder"],
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": [0, 1.25],
        "text-anchor": "top",
      },
      paint: {
        "icon-color": [
          "match", // Use the 'match' expression: https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-match
          ["get", "_IconValue"], // Use the result 'STORE_TYPE' property
          "1",
          "#008000",
          "2",
          "#FF0000",
          "#9ACD32", // any other store type
        ],
      },
    });
  }

  CreateMap(
    container: string,
    Style: string,
    Zoom: number,
    Lng: number,
    Lat: number
  ) {
    this.container = container;
    this.style = Style;
    this.zoom = Zoom;
    this.lng = Lng;
    this.lat = Lat;
    // var now = new Date();
    // var dif = now.getTime() - this.dateMap.getTime();
    // console.log("diferencia", dif);

    console.log("CREATING MAP");
    this._map = new mapboxgl.Map({
      container: container,
      style: Style,
      zoom: Zoom,
      pitch: 0,
      center: [Lng, Lat],
    });
    // this.dateMap = new Date();

    const mapContainer = document.getElementById(container);
    if (mapContainer) {
      mapContainer.style.userSelect = 'none';
      mapContainer.style.webkitUserSelect = 'none';
    }
  }

  AddControlNavigation() {
    if (this._containsControlNavigation == true) {
      this._map.addControl(new mapboxgl.NavigationControl());
      this._containsControlNavigation = true;
    }
  }

  AddControlFullScreen() {
    if (this._containsControlFullScreen == true) {
      this._map.addControl(new mapboxgl.FullscreenControl());
      this._containsControlFullScreen = true;
    }
  }

  AddControlGeolocalization() {
    if (this._containsControlGeolocalization == true) {
      {
        this._map.addControl(
          new mapboxgl.GeolocateControl({
            positionOptions: {
              enableHighAccuracy: true,
            },
            trackUserLocation: true,
          })
        );
        this._containsControlGeolocalization = true;
      }
    }
  }

  AddControlDraw() {
    var Draw = new MapboxDraw({
      displayControlsDefault: false,
      controls: {
        point: true,
        trash: true,
      },
    });
    this._map.addControl(Draw, "bottom-left");
  }

  setMap(map) {
    this._map = map;
  }

  FitBounds(geometry: any, padding: number = 100) {
    // console.log("FIT BOUNDS", geometry);
    let coordenadas: [number, number][] = [];

    if( geometry.type == "FeatureCollection" ){
      if( geometry.features.length == 0 )
        return;

      coordenadas = [];
      geometry.features.forEach( feature => {
        coordenadas.push( ...this.getFitBoundsCoords( feature.geometry ) );
      });
    }else{
      coordenadas = this.getFitBoundsCoords( geometry );
    }
      // console.log("COORDENADAS", coordenadas);
  
      // Crea el bounds con las coordenadas iniciales
      const bounds = new mapboxgl.LngLatBounds(coordenadas[0], coordenadas[0]);
  
      console.log("BOUNDS", bounds);
  
      // Extiende el bounds para que tenga todas las coordenadas.
      for (const coord of coordenadas) {
        bounds.extend(coord);
      }

      const sw = bounds.getSouthWest();
      const ne = bounds.getNorthEast();
      // console.log("SW", sw);
      // console.log("NE", ne);
      var isPunto = (sw.lng == ne.lng) && (sw.lat == ne.lat);
      if( isPunto ){
        const extender = 0.0005;
        bounds.setSouthWest( new mapboxgl.LngLat( sw.lng - extender, sw.lat - extender ) );
        bounds.setNorthEast( new mapboxgl.LngLat( ne.lng + extender, ne.lat + extender ) );
      }
  
      const bb = [
        [bounds.getSouthWest().lng, bounds.getSouthWest().lat],
        [bounds.getNorthEast().lng, bounds.getNorthEast().lat],
      ];
        this._map.fitBounds(bb, {
          padding: {top: padding, bottom:padding, left: padding+200, right: padding+100},
      });
    
  }

  getFitBoundsCoords(geometry: any): [number, number][] {
    // console.log("fitbounds GEOMETRY", geometry);
    
    let coordenadas: [number, number][] = [];
    if( geometry.type == "Point" ){
      var coordenada: [number, number] = geometry.coordinates as [number, number];
      coordenadas.push( coordenada );
    }

    if( geometry.type == "Polygon" ){
      var coordenadasPoligono: [number, number][] = geometry.coordinates[0];
      coordenadas.push(...coordenadasPoligono);
    }

    if( geometry.type == "LineString" ){
      coordenadas.push(...geometry.coordinates as [number, number][]);
    }

    //el multi tiene tres arrays el primero es de poligonos, el segundo es el de anillos y el tercero es el de puntos. 
    // el anillo exterior es el bueno y el resto es de anillos interiores que no importan ahorita
    //asi que el [ [ [ [lng, lat], [lng, lat] ] ], [ [ [lng, lat], [lng, lat] ] ] ]
    // o [ Poligono1[ Anillo1[ Puntos[Lng, Lat] ], Anillo2[ Puntos[Lng, Lat] ] ] , Poligono2[ Anillo1[ Puntos[Lng, Lat] ] ] ]  help
    if( geometry.type == "MultiPolygon" ){
      var poligonos: [number, number][][][] = geometry.coordinates;
      poligonos.forEach( poligono => {
        var coordenadasPoligono: [number, number][] = poligono[0]; // solo saco el 0 porque es la zona exterior del poligono, el resto no importa
        coordenadas.push(...coordenadasPoligono);
      });
    }

    // console.log("FIT BOUNDS COORDENADAS", coordenadas);

    return coordenadas;
  }

  InitialFly(lat: string, lng: string, zoom: string, pitch: number) {
    setTimeout( () => {
      this._map.flyTo({
        center: [lng, lat],
        zoom: zoom,
        // These options control the flight curve, making it move
        // slowly and zoom out almost completely before starting
        // to pan.
        speed: 1.5, // make the flying slow
        curve: 1, // change the speed at which it zooms out
        pitch: pitch,

        // This can be any easing function: it takes a number between
        // 0 and 1 and returns another number between 0 and 1.
        easing: function (t) {
          return t;
        },

        // this animation is considered essential with respect to prefers-reduced-motion
        essential: true,
      });
      // this._map.rotateCamera(0);
    }, 1000);
  }

  TourCamera(timestamp: number): void {
    setTimeout( () => {
      this._map.rotateTo(0, { duration: 3000 });
    }, 1000);
    setTimeout( () => {
      this._map.rotateTo(180, { duration: 3000 });
    }, 4000);
    setTimeout( () => {
      this._map.rotateTo(359, { duration: 3000 });
    }, 7000);
  }

  FlyToCameraFast(lat: string, lng: string, zoom: string) {
    console.log("MAP", this._map);
    this._map.flyTo({
      center: [lng, lat],
      pitch: 55,
      zoom: zoom,
      // These options control the flight curve, making it move
      // slowly and zoom out almost completely before starting
      // to pan.
      speed: 3, // make the flying slow
      curve: 1, // change the speed at which it zooms out

      // This can be any easing function: it takes a number between
      // 0 and 1 and returns another number between 0 and 1.
      easing: function (t) {
        return t;
      },

      // this animation is considered essential with respect to prefers-reduced-motion
      essential: true,
    });
  }

  FlyToCamera(lat: string, lng: string, zoom: string, pitch: number = 80) {
    this._map.flyTo({
      center: [lng, lat],
      pitch: pitch,
      zoom: zoom,
      // These options control the flight curve, making it move
      // slowly and zoom out almost completely before starting
      // to pan.
      speed: 2, // make the flying slow
      curve: 1, // change the speed at which it zooms out

      // This can be any easing function: it takes a number between
      // 0 and 1 and returns another number between 0 and 1.
      // easing: function (t) {
      //   return t;
      // },

      // this animation is considered essential with respect to prefers-reduced-motion
      essential: true,
    });
  }

  RotationCamera() {
    setTimeout(function () {
      this.rotateCamera(0);
    }, 20000);
  }

  rotateCamera(timestamp): void {
    // clamp the rotation between 0 -360 degrees
    // Divide timestamp by 100 to slow rotation to ~10 degrees / sec
    this._map.rotateTo((timestamp / 100) % 360, { duration: 0 });
    // Request the next frame of the animation.
    requestAnimationFrame(this.rotateCamera);
  }

  // ---funciones para el valet parking ---

  private valetParkingDragEvent = () => {
    // Obtener las coordenadas del centro del mapa y actualizar el punto central
    const center = this._map.getCenter();
    this._map.getSource('centerPointSource').setData({
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [center.lng, center.lat]
          }
        }
      ]
    });

    // Actualizar las coordenadas del valet parking y el buffer
    this.valetParkingService.coordsValetParking = { lat: center.lat, lng: center.lng};
    this.UpdateValetParkingBuffer();
  };
  
  CreateValetParkingDragEvent(){
    //crea el buffer inicial y el evento de drag
    this.AssignValetParkingServiceValues();
    this.FlyToCameraFast(this.bufferCenterLat.toString(), this.bufferCenterLng.toString(), "20");
    this.UpdateValetParkingBuffer();
    
    this._map.on("move", this.valetParkingDragEvent);
  }

  UpdateValetParkingBuffer(){
    this.AssignValetParkingServiceValues();
    var buffer = this.turfHelperService.getBufferGeoJSON(this.bufferCenterLat, this.bufferCenterLng, this.bufferRadioKm);
    this.UpdateLayerGeoJson("bufferActiveValetParkingSource", buffer);
    this.valetParkingService.bufferFeature = buffer;
  }

  DeleteValetParkingDragEvent(){
    this.bufferRadioKm = 0.1;
    this.valetParkingService.bufferFeature = null;

    this._map.off("move", this.valetParkingDragEvent);
  }

  AssignValetParkingServiceValues(){
    this.bufferCenterLat = this.valetParkingService.coordsValetParking.lat;
    this.bufferCenterLng = this.valetParkingService.coordsValetParking.lng;
    this.bufferRadioKm = this.valetParkingService.radioKm;
  }

  VerifyCarInValetParking(identifier: string){
    if(this.valetParkingService.bufferFeature == null)
      this.valetParkingService.bufferFeature = this.turfHelperService.getBufferGeoJSON(this.bufferCenterLat, this.bufferCenterLng, this.bufferRadioKm);

    var points = this._map.getSource("locationCarActiveSource")._data;
    var turfFeaturesInsideArea = this.turfHelperService.getPointsWithinPolygon( points, this.valetParkingService.bufferFeature );
    
    // busca el feature con la propiedad _Id igual al identifier
    const feature = turfFeaturesInsideArea.features.find(feature => feature.properties._Id === identifier);

    if (feature) {
      return true;
    }else {
      return false;
    }
  }

  isSourceEmpty(sourceName: string) {
    var source = this._map.getSource(sourceName);
    console.log('source', source._data);
    

    if (source) {
      
      if (source._data.features.length === 0) {
        console.log('El source está vacío');
        return true;
      } else {
        console.log('El source tiene features');
        return false;
      }
    } else {
      console.error('Source no encontrado');
      return true;
    }
  }

  toggleTraficLayer(visibilityValue: string) {
    const trafficLayers = this._map.getStyle().layers.filter(layer => 
      layer.id.includes('traffic')
    );
    trafficLayers.forEach(layer => {
      this._map.setLayoutProperty(layer.id, 'visibility', visibilityValue);
    });
  }

  // limpia el popup
  clearPopupEvents(mainClassName: string) {
    if (this._map) {
      const popups = document.getElementsByClassName('mapboxgl-popup');
      if (popups.length > 0) {
        Array.from(popups).forEach(popup => {
          if (popup.classList.contains(mainClassName)) {
            popup.remove();
          }
        });
      }
    }
  }
  
  async AddMapMatchedRoute(id: string, coordinates: number[][], lineColor: string = "#352F84") {
    try {
      console.log('Map Matched Route with coordinates:', coordinates);
      
      //no se hace el map match de momento, cambia a true si se quiere hacer el map match
      if (false) {
        // 100 es el máximo, si hay más los simplifica
        if (coordinates.length > 100) {
          coordinates = this.simplifyCoordinatesForMapMatching(coordinates, 100);
        }
        
        const coordsString = coordinates.map(coord => `${coord[0]},${coord[1]}`).join(';');
        const response = await fetch(
          `https://api.mapbox.com/matching/v5/mapbox/driving/${coordsString}?geometries=geojson&overview=full&access_token=${mapboxgl.accessToken}`
        );

          const data = await response.json();
          console.log('Map matched route data:', data);
          
          if (data.matchings && data.matchings.length > 0) {
            const matchedRoute = {
              type: "FeatureCollection",
              features: [{
                type: "Feature",
                geometry: data.matchings[0].geometry,
                properties: {
                  confidence: data.matchings[0].confidence
                }
              }]
            };
            const routeCoordinates = data.matchings[0].geometry.coordinates;
  
            const routeStart = {
              type: "FeatureCollection",
              features: [{
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: routeCoordinates[0]
                },
                properties: {
                  confidence: data.matchings[0].confidence
                }
              }]
            };
  
            const routeEnd = {
              type: "FeatureCollection",
              features: [{
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: routeCoordinates[routeCoordinates.length - 1]
                },
                properties: {
                  confidence: data.matchings[0].confidence
                }
              }]
            };
  
            const routeDialog = {
              "type": "FeatureCollection",
              "features": [
                {
                  "type": "Feature",
                  "geometry": {
                    "type": "Point",
                    "coordinates": routeCoordinates[Math.ceil(routeCoordinates.length / 5)]
                  },
                  "properties": {
                    "RTA": "15 horas 12 minutos",
                  }
                }
              ]
            };
  
            this.UpdateLayerGeoJson(id, matchedRoute);
            this.UpdateLayerGeoJson(id + "-Start", routeStart);
            this.UpdateLayerGeoJson(id + "-End", routeEnd);
            this.UpdateLayerGeoJson(id + "-Dialog", routeDialog);
            return;
          }
        
      }

      const directRoute = {
        type: "FeatureCollection",
        features: [{
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: coordinates
          },
          properties: {}
        }]
      };

      const routeStart = {
        type: "FeatureCollection",
        features: [{
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: coordinates[0]
          },
          properties: {
            type: "start",
            title: "Punto de inicio"
          }
        }]
      };
  
      const routeEnd = {
        type: "FeatureCollection",
        features: [{
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: coordinates[coordinates.length - 1]
          },
          properties: {
            type: "end",
            title: "Punto final"
          }
        }]
      };

      const routeDialog = {
            "type": "FeatureCollection",
            "features": [
              {
                "type": "Feature",
                "geometry": {
                  "type": "Point",
                  "coordinates": coordinates[Math.ceil(coordinates.length / 5)]
                },
                "properties": {
                  "RTA": "15 horas 12 minutos",
                }
              }
            ]
          };
      
      this.UpdateLayerGeoJson(id, directRoute);
      this.UpdateLayerGeoJson(id + "-Start", routeStart);
      this.UpdateLayerGeoJson(id + "-End", routeEnd);
      this.UpdateLayerGeoJson(id + "-Dialog", routeDialog);

      // si no acepta los 100, usa la que separa de 10 en 10  REVISAR SI AFECTA PRECIOS
      // await this.AddSnapToRoadsRoute(id, coordinates);

    } catch (error) {
      const directRoute = {
        type: "FeatureCollection",
        features: [{
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: coordinates
          },
          properties: {}
        }]
      };

      const routeStart = {
        type: "FeatureCollection",
        features: [{
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: coordinates[0]
          },
          properties: {
            type: "start",
            title: "Punto de inicio"
          }
        }]
      };
  
      const routeEnd = {
        type: "FeatureCollection",
        features: [{
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: coordinates[coordinates.length - 1]
          },
          properties: {
            type: "end",
            title: "Punto final"
          }
        }]
      };

      const routeDialog = {
            "type": "FeatureCollection",
            "features": [
              {
                "type": "Feature",
                "geometry": {
                  "type": "Point",
                  "coordinates": coordinates[Math.ceil(coordinates.length / 5)]
                },
                "properties": {
                  "RTA": "15 horas 12 minutos",
                }
              }
            ]
          };
      
      this.UpdateLayerGeoJson(id, directRoute);
      this.UpdateLayerGeoJson(id + "-Start", routeStart);
      this.UpdateLayerGeoJson(id + "-End", routeEnd);
      this.UpdateLayerGeoJson(id + "-Dialog", routeDialog);
    }
  }
  
  // otra funcion que ajusta puntos a calles usando match pequeños
  async AddSnapToRoadsRoute(id: string, coordinates: number[][]) {
    try {
      const snappedCoordinates: number[][] = [];
      
      // procesa en grupos más pequeños para evitar problemas de límite de puntos
      const pointsGroupSize = 10;
      for (let i = 0; i < coordinates.length; i += pointsGroupSize) {
        const pointsGroup = coordinates.slice(i, i + pointsGroupSize);
        const snappedPointGroup = await this.matchCoordsToStreet(pointsGroup);

        if (i > 0) {
          // Evitar duplicar el primer punto del grupo
          snappedCoordinates.push(...snappedPointGroup.slice(1));
        } else {
          snappedCoordinates.push(...snappedPointGroup);
        }
        
        // se epera un poco para evitar problemas de límite de solicitudes
        await new Promise(resolve => setTimeout(resolve, 50));
      }
      console.log('Map matched data piezas:', snappedCoordinates);
      const snappedRoute = {
        type: "FeatureCollection",
        features: [{
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: snappedCoordinates
          },
          properties: {}
        }]
      };
      
      this.UpdateLayerGeoJson(id, snappedRoute);
      
    } catch (error) {
      const directRoute = {
        type: "FeatureCollection",
        features: [{
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: coordinates
          },
          properties: {}
        }]
      };
      
      this.UpdateLayerGeoJson(id, directRoute);
    }
  }
  
  private async matchCoordsToStreet(coordinates: number[][]): Promise<number[][]> {
    if (coordinates.length < 2) return coordinates;
    
    const coordsString = coordinates.map(coord => `${coord[0]},${coord[1]}`).join(';');
    
    try {
      const response = await fetch(
        `https://api.mapbox.com/matching/v5/mapbox/driving/${coordsString}?geometries=geojson&overview=full&radiuses=${coordinates.map(() => '25').join(';')}&access_token=${mapboxgl.accessToken}`
      );
      
      if (response.ok) {
        const data = await response.json();
        if (data.matchings && data.matchings.length > 0) {
          return data.matchings[0].geometry.coordinates;
        }
      }
    } catch (error) {
    }
    
    return coordinates;
  }
  
  private simplifyCoordinatesForMapMatching(coordinates: number[][], maxPoints: number): number[][] {
    if (coordinates.length <= maxPoints) 
      return coordinates;
    
    // formula de internet "douglas-pecker" para simplificar puntos
    return this.mapUtilService.simplifyCoordinatesAdvanced(coordinates, 0.00005);
  }

}
const size = 200;

// This implements `StyleImageInterface`
// to draw a pulsing dot icon on the map.
const pulsingDot = {
  width: size,
  height: size,
  data: new Uint8Array(size * size * 4),

  // When the layer is added to the map,
  // get the rendering context for the map canvas.
  onAdd: function (map) {
    this.map = map;
    const canvas = document.createElement("canvas");
    canvas.width = this.width;
    canvas.height = this.height;
    this.context = canvas.getContext("2d");
  },

  // Call once before every frame where the icon will be used.
  render: function () {
    const duration = 2000;
    const t = (performance.now() % duration) / duration;

    const radius = (size / 2) * 0.5;
    const outerRadius = (size / 2) * 0.7 * t + radius;
    const context = this.context;

    // Draw the outer circle.
    context.clearRect(0, 0, this.width, this.height);
    context.beginPath();
    context.arc(this.width / 2, this.height / 2, outerRadius, 0, Math.PI * 2);
    context.fillStyle = `rgba(76, 243, 255, ${1 - t})`;
    context.fill();

    // Draw the inner circle.
    context.beginPath();
    context.arc(this.width / 2, this.height / 2, radius, 0, Math.PI * 2);
    context.fillStyle = "rgb(96, 244, 255)";
    context.strokeStyle = "white";
    context.lineWidth = 2 + 4 * (1 - t);
    context.fill();
    context.stroke();

    // Update this image's data with data from the canvas.
    this.data = context.getImageData(0, 0, this.width, this.height).data;

    // Continuously repaint the map, resulting
    // in the smooth animation of the dot.
    if (this.map) {
      this.map.triggerRepaint();
    }

    // Return `true` to let the map know that the image was updated.
    return true;
  },
};
